<script setup>
import { computed } from "vue";

defineProps({
  size: {
    type: Number,
    default: 120,
  },
});

const viewBoxWidth = import.meta.env.VITE_APP_ENV === "production" ? 1147 : 500;
const viewBoxHeight = import.meta.env.VITE_APP_ENV === "production" ? 1147 : 500;

const qr_version = computed(() => {
  const env = import.meta.env.VITE_APP_ENV;
  if (env === "production" || env === "staging") {
    return env;
  } else if (env.startsWith("test")) {
    return "test";
  }
  return "dev";
});
</script>
<template>
  <svg
    v-if="qr_version === 'production'"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    enable-background="new 0 0 1147 1147"
    xml:space="preserve"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`"
  >
    <rect x="0" y="0" width="1147" height="1147" fill="rgb(255,255,255)" />
    <g transform="translate(62,62)">
      <g transform="translate(248,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,0) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,31) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,62) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,93) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,93) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,93) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,93) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,93) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,124) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,155) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,186) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,217) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,248) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,279) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,310) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,341) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,372) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,403) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,434) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,465) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,496) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,527) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,558) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,589) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,620) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,651) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(217,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,682) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(155,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,713) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(31,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(93,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(124,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(186,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,744) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,775) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(589,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,806) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,837) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(806,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,868) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,899) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(403,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(651,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,930) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(279,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(310,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(434,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(465,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(682,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(899,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(930,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(961,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(992,961) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(248,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(341,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(372,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(496,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(527,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(558,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(620,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(713,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(744,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(775,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(837,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,992) scale(0.31,0.31)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(0,0) scale(2.17, 2.17)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <g>
            <rect x="15" y="15" style="fill: none;" width="70" height="70" />
            <path d="M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z" />
          </g>
        </g>
      </g>
      <g transform="translate(806,0) scale(2.17, 2.17)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <g>
            <rect x="15" y="15" style="fill: none;" width="70" height="70" />
            <path d="M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z" />
          </g>
        </g>
      </g>
      <g transform="translate(0,806) scale(2.17, 2.17)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <g>
            <rect x="15" y="15" style="fill: none;" width="70" height="70" />
            <path d="M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z" />
          </g>
        </g>
      </g>
      <g transform="translate(62,62) scale(0.93, 0.93)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(868,62) scale(0.93, 0.93)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
      <g transform="translate(62,868) scale(0.93, 0.93)">
        <g transform="" style="fill: rgb(0, 0, 0);">
          <rect width="100" height="100" />
        </g>
      </g>
    </g>
  </svg>
  <svg
    v-else-if="qr_version === 'staging'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`"
  >
    <defs>
      <clipPath id="clip-path-dot-color">
        <rect x="19" y="131" width="14" height="14" transform="rotate(0,26,138)" />
        <rect x="19" y="145" width="14" height="14" transform="rotate(0,26,152)" />
        <rect x="19" y="159" width="14" height="14" transform="rotate(0,26,166)" />
        <rect x="19" y="173" width="14" height="14" transform="rotate(0,26,180)" />
        <rect x="19" y="187" width="14" height="14" transform="rotate(0,26,194)" />
        <rect x="19" y="201" width="14" height="14" transform="rotate(0,26,208)" />
        <rect x="19" y="285" width="14" height="14" transform="rotate(0,26,292)" />
        <rect x="19" y="313" width="14" height="14" transform="rotate(0,26,320)" />
        <rect x="19" y="327" width="14" height="14" transform="rotate(0,26,334)" />
        <rect x="19" y="341" width="14" height="14" transform="rotate(0,26,348)" />
        <rect x="33" y="159" width="14" height="14" transform="rotate(0,40,166)" />
        <rect x="33" y="173" width="14" height="14" transform="rotate(0,40,180)" />
        <rect x="33" y="187" width="14" height="14" transform="rotate(0,40,194)" />
        <rect x="33" y="229" width="14" height="14" transform="rotate(0,40,236)" />
        <rect x="33" y="243" width="14" height="14" transform="rotate(0,40,250)" />
        <rect x="33" y="257" width="14" height="14" transform="rotate(0,40,264)" />
        <rect x="33" y="313" width="14" height="14" transform="rotate(0,40,320)" />
        <rect x="33" y="341" width="14" height="14" transform="rotate(0,40,348)" />
        <rect x="33" y="355" width="14" height="14" transform="rotate(0,40,362)" />
        <rect x="47" y="131" width="14" height="14" transform="rotate(0,54,138)" />
        <rect x="47" y="187" width="14" height="14" transform="rotate(0,54,194)" />
        <rect x="47" y="201" width="14" height="14" transform="rotate(0,54,208)" />
        <rect x="47" y="215" width="14" height="14" transform="rotate(0,54,222)" />
        <rect x="47" y="243" width="14" height="14" transform="rotate(0,54,250)" />
        <rect x="47" y="257" width="14" height="14" transform="rotate(0,54,264)" />
        <rect x="47" y="271" width="14" height="14" transform="rotate(0,54,278)" />
        <rect x="47" y="285" width="14" height="14" transform="rotate(0,54,292)" />
        <rect x="47" y="341" width="14" height="14" transform="rotate(0,54,348)" />
        <rect x="61" y="131" width="14" height="14" transform="rotate(0,68,138)" />
        <rect x="61" y="173" width="14" height="14" transform="rotate(0,68,180)" />
        <rect x="61" y="215" width="14" height="14" transform="rotate(0,68,222)" />
        <rect x="61" y="243" width="14" height="14" transform="rotate(0,68,250)" />
        <rect x="61" y="271" width="14" height="14" transform="rotate(0,68,278)" />
        <rect x="61" y="285" width="14" height="14" transform="rotate(0,68,292)" />
        <rect x="61" y="299" width="14" height="14" transform="rotate(0,68,306)" />
        <rect x="61" y="327" width="14" height="14" transform="rotate(0,68,334)" />
        <rect x="61" y="341" width="14" height="14" transform="rotate(0,68,348)" />
        <rect x="75" y="145" width="14" height="14" transform="rotate(0,82,152)" />
        <rect x="75" y="159" width="14" height="14" transform="rotate(0,82,166)" />
        <rect x="75" y="173" width="14" height="14" transform="rotate(0,82,180)" />
        <rect x="75" y="201" width="14" height="14" transform="rotate(0,82,208)" />
        <rect x="75" y="215" width="14" height="14" transform="rotate(0,82,222)" />
        <rect x="75" y="229" width="14" height="14" transform="rotate(0,82,236)" />
        <rect x="75" y="243" width="14" height="14" transform="rotate(0,82,250)" />
        <rect x="75" y="341" width="14" height="14" transform="rotate(0,82,348)" />
        <rect x="89" y="131" width="14" height="14" transform="rotate(0,96,138)" />
        <rect x="89" y="159" width="14" height="14" transform="rotate(0,96,166)" />
        <rect x="89" y="173" width="14" height="14" transform="rotate(0,96,180)" />
        <rect x="89" y="187" width="14" height="14" transform="rotate(0,96,194)" />
        <rect x="89" y="215" width="14" height="14" transform="rotate(0,96,222)" />
        <rect x="89" y="229" width="14" height="14" transform="rotate(0,96,236)" />
        <rect x="89" y="243" width="14" height="14" transform="rotate(0,96,250)" />
        <rect x="89" y="257" width="14" height="14" transform="rotate(0,96,264)" />
        <rect x="89" y="285" width="14" height="14" transform="rotate(0,96,292)" />
        <rect x="89" y="355" width="14" height="14" transform="rotate(0,96,362)" />
        <rect x="103" y="131" width="14" height="14" transform="rotate(0,110,138)" />
        <rect x="103" y="159" width="14" height="14" transform="rotate(0,110,166)" />
        <rect x="103" y="187" width="14" height="14" transform="rotate(0,110,194)" />
        <rect x="103" y="215" width="14" height="14" transform="rotate(0,110,222)" />
        <rect x="103" y="243" width="14" height="14" transform="rotate(0,110,250)" />
        <rect x="103" y="271" width="14" height="14" transform="rotate(0,110,278)" />
        <rect x="103" y="299" width="14" height="14" transform="rotate(0,110,306)" />
        <rect x="103" y="327" width="14" height="14" transform="rotate(0,110,334)" />
        <rect x="103" y="355" width="14" height="14" transform="rotate(0,110,362)" />
        <rect x="117" y="131" width="14" height="14" transform="rotate(0,124,138)" />
        <rect x="117" y="159" width="14" height="14" transform="rotate(0,124,166)" />
        <rect x="117" y="173" width="14" height="14" transform="rotate(0,124,180)" />
        <rect x="117" y="187" width="14" height="14" transform="rotate(0,124,194)" />
        <rect x="117" y="201" width="14" height="14" transform="rotate(0,124,208)" />
        <rect x="117" y="215" width="14" height="14" transform="rotate(0,124,222)" />
        <rect x="117" y="229" width="14" height="14" transform="rotate(0,124,236)" />
        <rect x="117" y="243" width="14" height="14" transform="rotate(0,124,250)" />
        <rect x="117" y="257" width="14" height="14" transform="rotate(0,124,264)" />
        <rect x="117" y="313" width="14" height="14" transform="rotate(0,124,320)" />
        <rect x="117" y="341" width="14" height="14" transform="rotate(0,124,348)" />
        <rect x="117" y="355" width="14" height="14" transform="rotate(0,124,362)" />
        <rect x="131" y="33" width="14" height="14" transform="rotate(0,138,40)" />
        <rect x="131" y="61" width="14" height="14" transform="rotate(0,138,68)" />
        <rect x="131" y="89" width="14" height="14" transform="rotate(0,138,96)" />
        <rect x="131" y="103" width="14" height="14" transform="rotate(0,138,110)" />
        <rect x="131" y="117" width="14" height="14" transform="rotate(0,138,124)" />
        <rect x="131" y="131" width="14" height="14" transform="rotate(0,138,138)" />
        <rect x="131" y="145" width="14" height="14" transform="rotate(0,138,152)" />
        <rect x="131" y="159" width="14" height="14" transform="rotate(0,138,166)" />
        <rect x="131" y="243" width="14" height="14" transform="rotate(0,138,250)" />
        <rect x="131" y="313" width="14" height="14" transform="rotate(0,138,320)" />
        <rect x="131" y="355" width="14" height="14" transform="rotate(0,138,362)" />
        <rect x="131" y="369" width="14" height="14" transform="rotate(0,138,376)" />
        <rect x="131" y="383" width="14" height="14" transform="rotate(0,138,390)" />
        <rect x="131" y="397" width="14" height="14" transform="rotate(0,138,404)" />
        <rect x="131" y="425" width="14" height="14" transform="rotate(0,138,432)" />
        <rect x="131" y="439" width="14" height="14" transform="rotate(0,138,446)" />
        <rect x="131" y="467" width="14" height="14" transform="rotate(0,138,474)" />
        <rect x="145" y="47" width="14" height="14" transform="rotate(0,152,54)" />
        <rect x="145" y="61" width="14" height="14" transform="rotate(0,152,68)" />
        <rect x="145" y="117" width="14" height="14" transform="rotate(0,152,124)" />
        <rect x="145" y="131" width="14" height="14" transform="rotate(0,152,138)" />
        <rect x="145" y="145" width="14" height="14" transform="rotate(0,152,152)" />
        <rect x="145" y="159" width="14" height="14" transform="rotate(0,152,166)" />
        <rect x="145" y="173" width="14" height="14" transform="rotate(0,152,180)" />
        <rect x="145" y="201" width="14" height="14" transform="rotate(0,152,208)" />
        <rect x="145" y="215" width="14" height="14" transform="rotate(0,152,222)" />
        <rect x="145" y="229" width="14" height="14" transform="rotate(0,152,236)" />
        <rect x="145" y="243" width="14" height="14" transform="rotate(0,152,250)" />
        <rect x="145" y="257" width="14" height="14" transform="rotate(0,152,264)" />
        <rect x="145" y="299" width="14" height="14" transform="rotate(0,152,306)" />
        <rect x="145" y="327" width="14" height="14" transform="rotate(0,152,334)" />
        <rect x="145" y="355" width="14" height="14" transform="rotate(0,152,362)" />
        <rect x="145" y="369" width="14" height="14" transform="rotate(0,152,376)" />
        <rect x="145" y="383" width="14" height="14" transform="rotate(0,152,390)" />
        <rect x="145" y="397" width="14" height="14" transform="rotate(0,152,404)" />
        <rect x="145" y="453" width="14" height="14" transform="rotate(0,152,460)" />
        <rect x="145" y="467" width="14" height="14" transform="rotate(0,152,474)" />
        <rect x="159" y="19" width="14" height="14" transform="rotate(0,166,26)" />
        <rect x="159" y="33" width="14" height="14" transform="rotate(0,166,40)" />
        <rect x="159" y="47" width="14" height="14" transform="rotate(0,166,54)" />
        <rect x="159" y="103" width="14" height="14" transform="rotate(0,166,110)" />
        <rect x="159" y="117" width="14" height="14" transform="rotate(0,166,124)" />
        <rect x="159" y="159" width="14" height="14" transform="rotate(0,166,166)" />
        <rect x="159" y="173" width="14" height="14" transform="rotate(0,166,180)" />
        <rect x="159" y="229" width="14" height="14" transform="rotate(0,166,236)" />
        <rect x="159" y="243" width="14" height="14" transform="rotate(0,166,250)" />
        <rect x="159" y="271" width="14" height="14" transform="rotate(0,166,278)" />
        <rect x="159" y="285" width="14" height="14" transform="rotate(0,166,292)" />
        <rect x="159" y="313" width="14" height="14" transform="rotate(0,166,320)" />
        <rect x="159" y="327" width="14" height="14" transform="rotate(0,166,334)" />
        <rect x="159" y="355" width="14" height="14" transform="rotate(0,166,362)" />
        <rect x="159" y="383" width="14" height="14" transform="rotate(0,166,390)" />
        <rect x="159" y="397" width="14" height="14" transform="rotate(0,166,404)" />
        <rect x="159" y="411" width="14" height="14" transform="rotate(0,166,418)" />
        <rect x="159" y="439" width="14" height="14" transform="rotate(0,166,446)" />
        <rect x="159" y="453" width="14" height="14" transform="rotate(0,166,460)" />
        <rect x="159" y="467" width="14" height="14" transform="rotate(0,166,474)" />
        <rect x="173" y="47" width="14" height="14" transform="rotate(0,180,54)" />
        <rect x="173" y="75" width="14" height="14" transform="rotate(0,180,82)" />
        <rect x="173" y="89" width="14" height="14" transform="rotate(0,180,96)" />
        <rect x="173" y="159" width="14" height="14" transform="rotate(0,180,166)" />
        <rect x="173" y="173" width="14" height="14" transform="rotate(0,180,180)" />
        <rect x="173" y="215" width="14" height="14" transform="rotate(0,180,222)" />
        <rect x="173" y="243" width="14" height="14" transform="rotate(0,180,250)" />
        <rect x="173" y="285" width="14" height="14" transform="rotate(0,180,292)" />
        <rect x="173" y="299" width="14" height="14" transform="rotate(0,180,306)" />
        <rect x="173" y="313" width="14" height="14" transform="rotate(0,180,320)" />
        <rect x="173" y="327" width="14" height="14" transform="rotate(0,180,334)" />
        <rect x="173" y="341" width="14" height="14" transform="rotate(0,180,348)" />
        <rect x="173" y="355" width="14" height="14" transform="rotate(0,180,362)" />
        <rect x="173" y="411" width="14" height="14" transform="rotate(0,180,418)" />
        <rect x="173" y="425" width="14" height="14" transform="rotate(0,180,432)" />
        <rect x="173" y="453" width="14" height="14" transform="rotate(0,180,460)" />
        <rect x="173" y="467" width="14" height="14" transform="rotate(0,180,474)" />
        <rect x="187" y="33" width="14" height="14" transform="rotate(0,194,40)" />
        <rect x="187" y="103" width="14" height="14" transform="rotate(0,194,110)" />
        <rect x="187" y="117" width="14" height="14" transform="rotate(0,194,124)" />
        <rect x="187" y="159" width="14" height="14" transform="rotate(0,194,166)" />
        <rect x="187" y="173" width="14" height="14" transform="rotate(0,194,180)" />
        <rect x="187" y="201" width="14" height="14" transform="rotate(0,194,208)" />
        <rect x="187" y="229" width="14" height="14" transform="rotate(0,194,236)" />
        <rect x="187" y="243" width="14" height="14" transform="rotate(0,194,250)" />
        <rect x="187" y="271" width="14" height="14" transform="rotate(0,194,278)" />
        <rect x="187" y="299" width="14" height="14" transform="rotate(0,194,306)" />
        <rect x="187" y="313" width="14" height="14" transform="rotate(0,194,320)" />
        <rect x="187" y="341" width="14" height="14" transform="rotate(0,194,348)" />
        <rect x="187" y="355" width="14" height="14" transform="rotate(0,194,362)" />
        <rect x="187" y="369" width="14" height="14" transform="rotate(0,194,376)" />
        <rect x="187" y="383" width="14" height="14" transform="rotate(0,194,390)" />
        <rect x="187" y="425" width="14" height="14" transform="rotate(0,194,432)" />
        <rect x="187" y="453" width="14" height="14" transform="rotate(0,194,460)" />
        <rect x="187" y="467" width="14" height="14" transform="rotate(0,194,474)" />
        <rect x="201" y="19" width="14" height="14" transform="rotate(0,208,26)" />
        <rect x="201" y="33" width="14" height="14" transform="rotate(0,208,40)" />
        <rect x="201" y="75" width="14" height="14" transform="rotate(0,208,82)" />
        <rect x="201" y="89" width="14" height="14" transform="rotate(0,208,96)" />
        <rect x="201" y="117" width="14" height="14" transform="rotate(0,208,124)" />
        <rect x="201" y="131" width="14" height="14" transform="rotate(0,208,138)" />
        <rect x="201" y="173" width="14" height="14" transform="rotate(0,208,180)" />
        <rect x="201" y="229" width="14" height="14" transform="rotate(0,208,236)" />
        <rect x="201" y="243" width="14" height="14" transform="rotate(0,208,250)" />
        <rect x="201" y="285" width="14" height="14" transform="rotate(0,208,292)" />
        <rect x="201" y="299" width="14" height="14" transform="rotate(0,208,306)" />
        <rect x="201" y="313" width="14" height="14" transform="rotate(0,208,320)" />
        <rect x="201" y="327" width="14" height="14" transform="rotate(0,208,334)" />
        <rect x="201" y="383" width="14" height="14" transform="rotate(0,208,390)" />
        <rect x="201" y="411" width="14" height="14" transform="rotate(0,208,418)" />
        <rect x="201" y="439" width="14" height="14" transform="rotate(0,208,446)" />
        <rect x="201" y="453" width="14" height="14" transform="rotate(0,208,460)" />
        <rect x="201" y="467" width="14" height="14" transform="rotate(0,208,474)" />
        <rect x="215" y="47" width="14" height="14" transform="rotate(0,222,54)" />
        <rect x="215" y="61" width="14" height="14" transform="rotate(0,222,68)" />
        <rect x="215" y="75" width="14" height="14" transform="rotate(0,222,82)" />
        <rect x="215" y="103" width="14" height="14" transform="rotate(0,222,110)" />
        <rect x="215" y="145" width="14" height="14" transform="rotate(0,222,152)" />
        <rect x="215" y="159" width="14" height="14" transform="rotate(0,222,166)" />
        <rect x="215" y="173" width="14" height="14" transform="rotate(0,222,180)" />
        <rect x="215" y="187" width="14" height="14" transform="rotate(0,222,194)" />
        <rect x="215" y="201" width="14" height="14" transform="rotate(0,222,208)" />
        <rect x="215" y="215" width="14" height="14" transform="rotate(0,222,222)" />
        <rect x="215" y="243" width="14" height="14" transform="rotate(0,222,250)" />
        <rect x="215" y="299" width="14" height="14" transform="rotate(0,222,306)" />
        <rect x="215" y="341" width="14" height="14" transform="rotate(0,222,348)" />
        <rect x="215" y="369" width="14" height="14" transform="rotate(0,222,376)" />
        <rect x="215" y="383" width="14" height="14" transform="rotate(0,222,390)" />
        <rect x="215" y="397" width="14" height="14" transform="rotate(0,222,404)" />
        <rect x="215" y="425" width="14" height="14" transform="rotate(0,222,432)" />
        <rect x="215" y="453" width="14" height="14" transform="rotate(0,222,460)" />
        <rect x="229" y="47" width="14" height="14" transform="rotate(0,236,54)" />
        <rect x="229" y="61" width="14" height="14" transform="rotate(0,236,68)" />
        <rect x="229" y="131" width="14" height="14" transform="rotate(0,236,138)" />
        <rect x="229" y="173" width="14" height="14" transform="rotate(0,236,180)" />
        <rect x="229" y="187" width="14" height="14" transform="rotate(0,236,194)" />
        <rect x="229" y="215" width="14" height="14" transform="rotate(0,236,222)" />
        <rect x="229" y="285" width="14" height="14" transform="rotate(0,236,292)" />
        <rect x="229" y="299" width="14" height="14" transform="rotate(0,236,306)" />
        <rect x="229" y="313" width="14" height="14" transform="rotate(0,236,320)" />
        <rect x="229" y="355" width="14" height="14" transform="rotate(0,236,362)" />
        <rect x="229" y="383" width="14" height="14" transform="rotate(0,236,390)" />
        <rect x="229" y="411" width="14" height="14" transform="rotate(0,236,418)" />
        <rect x="229" y="453" width="14" height="14" transform="rotate(0,236,460)" />
        <rect x="243" y="19" width="14" height="14" transform="rotate(0,250,26)" />
        <rect x="243" y="33" width="14" height="14" transform="rotate(0,250,40)" />
        <rect x="243" y="47" width="14" height="14" transform="rotate(0,250,54)" />
        <rect x="243" y="61" width="14" height="14" transform="rotate(0,250,68)" />
        <rect x="243" y="75" width="14" height="14" transform="rotate(0,250,82)" />
        <rect x="243" y="103" width="14" height="14" transform="rotate(0,250,110)" />
        <rect x="243" y="159" width="14" height="14" transform="rotate(0,250,166)" />
        <rect x="243" y="201" width="14" height="14" transform="rotate(0,250,208)" />
        <rect x="243" y="215" width="14" height="14" transform="rotate(0,250,222)" />
        <rect x="243" y="257" width="14" height="14" transform="rotate(0,250,264)" />
        <rect x="243" y="299" width="14" height="14" transform="rotate(0,250,306)" />
        <rect x="243" y="313" width="14" height="14" transform="rotate(0,250,320)" />
        <rect x="243" y="341" width="14" height="14" transform="rotate(0,250,348)" />
        <rect x="243" y="355" width="14" height="14" transform="rotate(0,250,362)" />
        <rect x="243" y="383" width="14" height="14" transform="rotate(0,250,390)" />
        <rect x="243" y="411" width="14" height="14" transform="rotate(0,250,418)" />
        <rect x="243" y="453" width="14" height="14" transform="rotate(0,250,460)" />
        <rect x="257" y="19" width="14" height="14" transform="rotate(0,264,26)" />
        <rect x="257" y="33" width="14" height="14" transform="rotate(0,264,40)" />
        <rect x="257" y="47" width="14" height="14" transform="rotate(0,264,54)" />
        <rect x="257" y="61" width="14" height="14" transform="rotate(0,264,68)" />
        <rect x="257" y="75" width="14" height="14" transform="rotate(0,264,82)" />
        <rect x="257" y="117" width="14" height="14" transform="rotate(0,264,124)" />
        <rect x="257" y="145" width="14" height="14" transform="rotate(0,264,152)" />
        <rect x="257" y="201" width="14" height="14" transform="rotate(0,264,208)" />
        <rect x="257" y="229" width="14" height="14" transform="rotate(0,264,236)" />
        <rect x="257" y="243" width="14" height="14" transform="rotate(0,264,250)" />
        <rect x="257" y="313" width="14" height="14" transform="rotate(0,264,320)" />
        <rect x="257" y="341" width="14" height="14" transform="rotate(0,264,348)" />
        <rect x="257" y="355" width="14" height="14" transform="rotate(0,264,362)" />
        <rect x="257" y="369" width="14" height="14" transform="rotate(0,264,376)" />
        <rect x="257" y="397" width="14" height="14" transform="rotate(0,264,404)" />
        <rect x="257" y="425" width="14" height="14" transform="rotate(0,264,432)" />
        <rect x="257" y="453" width="14" height="14" transform="rotate(0,264,460)" />
        <rect x="271" y="19" width="14" height="14" transform="rotate(0,278,26)" />
        <rect x="271" y="33" width="14" height="14" transform="rotate(0,278,40)" />
        <rect x="271" y="103" width="14" height="14" transform="rotate(0,278,110)" />
        <rect x="271" y="117" width="14" height="14" transform="rotate(0,278,124)" />
        <rect x="271" y="145" width="14" height="14" transform="rotate(0,278,152)" />
        <rect x="271" y="159" width="14" height="14" transform="rotate(0,278,166)" />
        <rect x="271" y="173" width="14" height="14" transform="rotate(0,278,180)" />
        <rect x="271" y="187" width="14" height="14" transform="rotate(0,278,194)" />
        <rect x="271" y="229" width="14" height="14" transform="rotate(0,278,236)" />
        <rect x="271" y="243" width="14" height="14" transform="rotate(0,278,250)" />
        <rect x="271" y="271" width="14" height="14" transform="rotate(0,278,278)" />
        <rect x="271" y="313" width="14" height="14" transform="rotate(0,278,320)" />
        <rect x="271" y="327" width="14" height="14" transform="rotate(0,278,334)" />
        <rect x="271" y="355" width="14" height="14" transform="rotate(0,278,362)" />
        <rect x="271" y="369" width="14" height="14" transform="rotate(0,278,376)" />
        <rect x="271" y="439" width="14" height="14" transform="rotate(0,278,446)" />
        <rect x="271" y="453" width="14" height="14" transform="rotate(0,278,460)" />
        <rect x="271" y="467" width="14" height="14" transform="rotate(0,278,474)" />
        <rect x="285" y="33" width="14" height="14" transform="rotate(0,292,40)" />
        <rect x="285" y="47" width="14" height="14" transform="rotate(0,292,54)" />
        <rect x="285" y="89" width="14" height="14" transform="rotate(0,292,96)" />
        <rect x="285" y="117" width="14" height="14" transform="rotate(0,292,124)" />
        <rect x="285" y="159" width="14" height="14" transform="rotate(0,292,166)" />
        <rect x="285" y="173" width="14" height="14" transform="rotate(0,292,180)" />
        <rect x="285" y="187" width="14" height="14" transform="rotate(0,292,194)" />
        <rect x="285" y="201" width="14" height="14" transform="rotate(0,292,208)" />
        <rect x="285" y="215" width="14" height="14" transform="rotate(0,292,222)" />
        <rect x="285" y="257" width="14" height="14" transform="rotate(0,292,264)" />
        <rect x="285" y="313" width="14" height="14" transform="rotate(0,292,320)" />
        <rect x="285" y="327" width="14" height="14" transform="rotate(0,292,334)" />
        <rect x="285" y="355" width="14" height="14" transform="rotate(0,292,362)" />
        <rect x="285" y="369" width="14" height="14" transform="rotate(0,292,376)" />
        <rect x="285" y="383" width="14" height="14" transform="rotate(0,292,390)" />
        <rect x="285" y="397" width="14" height="14" transform="rotate(0,292,404)" />
        <rect x="285" y="453" width="14" height="14" transform="rotate(0,292,460)" />
        <rect x="299" y="19" width="14" height="14" transform="rotate(0,306,26)" />
        <rect x="299" y="33" width="14" height="14" transform="rotate(0,306,40)" />
        <rect x="299" y="61" width="14" height="14" transform="rotate(0,306,68)" />
        <rect x="299" y="75" width="14" height="14" transform="rotate(0,306,82)" />
        <rect x="299" y="103" width="14" height="14" transform="rotate(0,306,110)" />
        <rect x="299" y="131" width="14" height="14" transform="rotate(0,306,138)" />
        <rect x="299" y="145" width="14" height="14" transform="rotate(0,306,152)" />
        <rect x="299" y="243" width="14" height="14" transform="rotate(0,306,250)" />
        <rect x="299" y="257" width="14" height="14" transform="rotate(0,306,264)" />
        <rect x="299" y="271" width="14" height="14" transform="rotate(0,306,278)" />
        <rect x="299" y="285" width="14" height="14" transform="rotate(0,306,292)" />
        <rect x="299" y="313" width="14" height="14" transform="rotate(0,306,320)" />
        <rect x="299" y="355" width="14" height="14" transform="rotate(0,306,362)" />
        <rect x="313" y="33" width="14" height="14" transform="rotate(0,320,40)" />
        <rect x="313" y="47" width="14" height="14" transform="rotate(0,320,54)" />
        <rect x="313" y="61" width="14" height="14" transform="rotate(0,320,68)" />
        <rect x="313" y="159" width="14" height="14" transform="rotate(0,320,166)" />
        <rect x="313" y="173" width="14" height="14" transform="rotate(0,320,180)" />
        <rect x="313" y="187" width="14" height="14" transform="rotate(0,320,194)" />
        <rect x="313" y="201" width="14" height="14" transform="rotate(0,320,208)" />
        <rect x="313" y="229" width="14" height="14" transform="rotate(0,320,236)" />
        <rect x="313" y="243" width="14" height="14" transform="rotate(0,320,250)" />
        <rect x="313" y="257" width="14" height="14" transform="rotate(0,320,264)" />
        <rect x="313" y="355" width="14" height="14" transform="rotate(0,320,362)" />
        <rect x="313" y="369" width="14" height="14" transform="rotate(0,320,376)" />
        <rect x="313" y="383" width="14" height="14" transform="rotate(0,320,390)" />
        <rect x="313" y="397" width="14" height="14" transform="rotate(0,320,404)" />
        <rect x="313" y="425" width="14" height="14" transform="rotate(0,320,432)" />
        <rect x="313" y="453" width="14" height="14" transform="rotate(0,320,460)" />
        <rect x="313" y="467" width="14" height="14" transform="rotate(0,320,474)" />
        <rect x="327" y="19" width="14" height="14" transform="rotate(0,334,26)" />
        <rect x="327" y="33" width="14" height="14" transform="rotate(0,334,40)" />
        <rect x="327" y="89" width="14" height="14" transform="rotate(0,334,96)" />
        <rect x="327" y="103" width="14" height="14" transform="rotate(0,334,110)" />
        <rect x="327" y="131" width="14" height="14" transform="rotate(0,334,138)" />
        <rect x="327" y="215" width="14" height="14" transform="rotate(0,334,222)" />
        <rect x="327" y="229" width="14" height="14" transform="rotate(0,334,236)" />
        <rect x="327" y="243" width="14" height="14" transform="rotate(0,334,250)" />
        <rect x="327" y="271" width="14" height="14" transform="rotate(0,334,278)" />
        <rect x="327" y="285" width="14" height="14" transform="rotate(0,334,292)" />
        <rect x="327" y="313" width="14" height="14" transform="rotate(0,334,320)" />
        <rect x="327" y="327" width="14" height="14" transform="rotate(0,334,334)" />
        <rect x="327" y="355" width="14" height="14" transform="rotate(0,334,362)" />
        <rect x="327" y="369" width="14" height="14" transform="rotate(0,334,376)" />
        <rect x="327" y="383" width="14" height="14" transform="rotate(0,334,390)" />
        <rect x="327" y="425" width="14" height="14" transform="rotate(0,334,432)" />
        <rect x="327" y="439" width="14" height="14" transform="rotate(0,334,446)" />
        <rect x="327" y="467" width="14" height="14" transform="rotate(0,334,474)" />
        <rect x="341" y="33" width="14" height="14" transform="rotate(0,348,40)" />
        <rect x="341" y="47" width="14" height="14" transform="rotate(0,348,54)" />
        <rect x="341" y="75" width="14" height="14" transform="rotate(0,348,82)" />
        <rect x="341" y="187" width="14" height="14" transform="rotate(0,348,194)" />
        <rect x="341" y="229" width="14" height="14" transform="rotate(0,348,236)" />
        <rect x="341" y="243" width="14" height="14" transform="rotate(0,348,250)" />
        <rect x="341" y="257" width="14" height="14" transform="rotate(0,348,264)" />
        <rect x="341" y="285" width="14" height="14" transform="rotate(0,348,292)" />
        <rect x="341" y="313" width="14" height="14" transform="rotate(0,348,320)" />
        <rect x="341" y="355" width="14" height="14" transform="rotate(0,348,362)" />
        <rect x="341" y="397" width="14" height="14" transform="rotate(0,348,404)" />
        <rect x="341" y="425" width="14" height="14" transform="rotate(0,348,432)" />
        <rect x="341" y="453" width="14" height="14" transform="rotate(0,348,460)" />
        <rect x="355" y="19" width="14" height="14" transform="rotate(0,362,26)" />
        <rect x="355" y="61" width="14" height="14" transform="rotate(0,362,68)" />
        <rect x="355" y="75" width="14" height="14" transform="rotate(0,362,82)" />
        <rect x="355" y="89" width="14" height="14" transform="rotate(0,362,96)" />
        <rect x="355" y="103" width="14" height="14" transform="rotate(0,362,110)" />
        <rect x="355" y="117" width="14" height="14" transform="rotate(0,362,124)" />
        <rect x="355" y="131" width="14" height="14" transform="rotate(0,362,138)" />
        <rect x="355" y="145" width="14" height="14" transform="rotate(0,362,152)" />
        <rect x="355" y="159" width="14" height="14" transform="rotate(0,362,166)" />
        <rect x="355" y="215" width="14" height="14" transform="rotate(0,362,222)" />
        <rect x="355" y="271" width="14" height="14" transform="rotate(0,362,278)" />
        <rect x="355" y="299" width="14" height="14" transform="rotate(0,362,306)" />
        <rect x="355" y="313" width="14" height="14" transform="rotate(0,362,320)" />
        <rect x="355" y="355" width="14" height="14" transform="rotate(0,362,362)" />
        <rect x="355" y="369" width="14" height="14" transform="rotate(0,362,376)" />
        <rect x="355" y="383" width="14" height="14" transform="rotate(0,362,390)" />
        <rect x="355" y="397" width="14" height="14" transform="rotate(0,362,404)" />
        <rect x="355" y="411" width="14" height="14" transform="rotate(0,362,418)" />
        <rect x="355" y="425" width="14" height="14" transform="rotate(0,362,432)" />
        <rect x="355" y="453" width="14" height="14" transform="rotate(0,362,460)" />
        <rect x="369" y="131" width="14" height="14" transform="rotate(0,376,138)" />
        <rect x="369" y="145" width="14" height="14" transform="rotate(0,376,152)" />
        <rect x="369" y="159" width="14" height="14" transform="rotate(0,376,166)" />
        <rect x="369" y="187" width="14" height="14" transform="rotate(0,376,194)" />
        <rect x="369" y="201" width="14" height="14" transform="rotate(0,376,208)" />
        <rect x="369" y="215" width="14" height="14" transform="rotate(0,376,222)" />
        <rect x="369" y="243" width="14" height="14" transform="rotate(0,376,250)" />
        <rect x="369" y="285" width="14" height="14" transform="rotate(0,376,292)" />
        <rect x="369" y="299" width="14" height="14" transform="rotate(0,376,306)" />
        <rect x="369" y="327" width="14" height="14" transform="rotate(0,376,334)" />
        <rect x="369" y="341" width="14" height="14" transform="rotate(0,376,348)" />
        <rect x="369" y="355" width="14" height="14" transform="rotate(0,376,362)" />
        <rect x="369" y="411" width="14" height="14" transform="rotate(0,376,418)" />
        <rect x="369" y="425" width="14" height="14" transform="rotate(0,376,432)" />
        <rect x="369" y="467" width="14" height="14" transform="rotate(0,376,474)" />
        <rect x="383" y="131" width="14" height="14" transform="rotate(0,390,138)" />
        <rect x="383" y="145" width="14" height="14" transform="rotate(0,390,152)" />
        <rect x="383" y="159" width="14" height="14" transform="rotate(0,390,166)" />
        <rect x="383" y="173" width="14" height="14" transform="rotate(0,390,180)" />
        <rect x="383" y="187" width="14" height="14" transform="rotate(0,390,194)" />
        <rect x="383" y="243" width="14" height="14" transform="rotate(0,390,250)" />
        <rect x="383" y="257" width="14" height="14" transform="rotate(0,390,264)" />
        <rect x="383" y="327" width="14" height="14" transform="rotate(0,390,334)" />
        <rect x="383" y="355" width="14" height="14" transform="rotate(0,390,362)" />
        <rect x="383" y="383" width="14" height="14" transform="rotate(0,390,390)" />
        <rect x="383" y="411" width="14" height="14" transform="rotate(0,390,418)" />
        <rect x="383" y="425" width="14" height="14" transform="rotate(0,390,432)" />
        <rect x="383" y="439" width="14" height="14" transform="rotate(0,390,446)" />
        <rect x="383" y="453" width="14" height="14" transform="rotate(0,390,460)" />
        <rect x="397" y="131" width="14" height="14" transform="rotate(0,404,138)" />
        <rect x="397" y="145" width="14" height="14" transform="rotate(0,404,152)" />
        <rect x="397" y="201" width="14" height="14" transform="rotate(0,404,208)" />
        <rect x="397" y="215" width="14" height="14" transform="rotate(0,404,222)" />
        <rect x="397" y="229" width="14" height="14" transform="rotate(0,404,236)" />
        <rect x="397" y="285" width="14" height="14" transform="rotate(0,404,292)" />
        <rect x="397" y="313" width="14" height="14" transform="rotate(0,404,320)" />
        <rect x="397" y="327" width="14" height="14" transform="rotate(0,404,334)" />
        <rect x="397" y="355" width="14" height="14" transform="rotate(0,404,362)" />
        <rect x="397" y="411" width="14" height="14" transform="rotate(0,404,418)" />
        <rect x="397" y="467" width="14" height="14" transform="rotate(0,404,474)" />
        <rect x="411" y="145" width="14" height="14" transform="rotate(0,418,152)" />
        <rect x="411" y="159" width="14" height="14" transform="rotate(0,418,166)" />
        <rect x="411" y="173" width="14" height="14" transform="rotate(0,418,180)" />
        <rect x="411" y="201" width="14" height="14" transform="rotate(0,418,208)" />
        <rect x="411" y="229" width="14" height="14" transform="rotate(0,418,236)" />
        <rect x="411" y="285" width="14" height="14" transform="rotate(0,418,292)" />
        <rect x="411" y="299" width="14" height="14" transform="rotate(0,418,306)" />
        <rect x="411" y="313" width="14" height="14" transform="rotate(0,418,320)" />
        <rect x="411" y="327" width="14" height="14" transform="rotate(0,418,334)" />
        <rect x="411" y="355" width="14" height="14" transform="rotate(0,418,362)" />
        <rect x="411" y="369" width="14" height="14" transform="rotate(0,418,376)" />
        <rect x="411" y="383" width="14" height="14" transform="rotate(0,418,390)" />
        <rect x="411" y="397" width="14" height="14" transform="rotate(0,418,404)" />
        <rect x="411" y="411" width="14" height="14" transform="rotate(0,418,418)" />
        <rect x="411" y="425" width="14" height="14" transform="rotate(0,418,432)" />
        <rect x="425" y="131" width="14" height="14" transform="rotate(0,432,138)" />
        <rect x="425" y="145" width="14" height="14" transform="rotate(0,432,152)" />
        <rect x="425" y="159" width="14" height="14" transform="rotate(0,432,166)" />
        <rect x="425" y="215" width="14" height="14" transform="rotate(0,432,222)" />
        <rect x="425" y="243" width="14" height="14" transform="rotate(0,432,250)" />
        <rect x="425" y="313" width="14" height="14" transform="rotate(0,432,320)" />
        <rect x="425" y="341" width="14" height="14" transform="rotate(0,432,348)" />
        <rect x="425" y="355" width="14" height="14" transform="rotate(0,432,362)" />
        <rect x="425" y="383" width="14" height="14" transform="rotate(0,432,390)" />
        <rect x="425" y="411" width="14" height="14" transform="rotate(0,432,418)" />
        <rect x="425" y="453" width="14" height="14" transform="rotate(0,432,460)" />
        <rect x="439" y="159" width="14" height="14" transform="rotate(0,446,166)" />
        <rect x="439" y="187" width="14" height="14" transform="rotate(0,446,194)" />
        <rect x="439" y="229" width="14" height="14" transform="rotate(0,446,236)" />
        <rect x="439" y="243" width="14" height="14" transform="rotate(0,446,250)" />
        <rect x="439" y="271" width="14" height="14" transform="rotate(0,446,278)" />
        <rect x="439" y="299" width="14" height="14" transform="rotate(0,446,306)" />
        <rect x="439" y="327" width="14" height="14" transform="rotate(0,446,334)" />
        <rect x="439" y="341" width="14" height="14" transform="rotate(0,446,348)" />
        <rect x="439" y="411" width="14" height="14" transform="rotate(0,446,418)" />
        <rect x="439" y="439" width="14" height="14" transform="rotate(0,446,446)" />
        <rect x="439" y="467" width="14" height="14" transform="rotate(0,446,474)" />
        <rect x="453" y="131" width="14" height="14" transform="rotate(0,460,138)" />
        <rect x="453" y="159" width="14" height="14" transform="rotate(0,460,166)" />
        <rect x="453" y="173" width="14" height="14" transform="rotate(0,460,180)" />
        <rect x="453" y="201" width="14" height="14" transform="rotate(0,460,208)" />
        <rect x="453" y="215" width="14" height="14" transform="rotate(0,460,222)" />
        <rect x="453" y="271" width="14" height="14" transform="rotate(0,460,278)" />
        <rect x="453" y="299" width="14" height="14" transform="rotate(0,460,306)" />
        <rect x="453" y="313" width="14" height="14" transform="rotate(0,460,320)" />
        <rect x="453" y="355" width="14" height="14" transform="rotate(0,460,362)" />
        <rect x="453" y="369" width="14" height="14" transform="rotate(0,460,376)" />
        <rect x="453" y="383" width="14" height="14" transform="rotate(0,460,390)" />
        <rect x="467" y="145" width="14" height="14" transform="rotate(0,474,152)" />
        <rect x="467" y="173" width="14" height="14" transform="rotate(0,474,180)" />
        <rect x="467" y="187" width="14" height="14" transform="rotate(0,474,194)" />
        <rect x="467" y="243" width="14" height="14" transform="rotate(0,474,250)" />
        <rect x="467" y="285" width="14" height="14" transform="rotate(0,474,292)" />
        <rect x="467" y="299" width="14" height="14" transform="rotate(0,474,306)" />
        <rect x="467" y="313" width="14" height="14" transform="rotate(0,474,320)" />
        <rect x="467" y="355" width="14" height="14" transform="rotate(0,474,362)" />
        <rect x="467" y="369" width="14" height="14" transform="rotate(0,474,376)" />
        <rect x="467" y="411" width="14" height="14" transform="rotate(0,474,418)" />
        <rect x="467" y="453" width="14" height="14" transform="rotate(0,474,460)" />
        <path clip-rule="evenodd" d="M 19 19v 98h 98v -98zM 33 33h 70v 70h -70z" transform="rotate(0,68,68)" />
        <rect x="47" y="47" width="42" height="42" transform="rotate(0,68,68)" />
        <path clip-rule="evenodd" d="M 383 19v 98h 98v -98zM 397 33h 70v 70h -70z" transform="rotate(90,432,68)" />
        <rect x="411" y="47" width="42" height="42" transform="rotate(90,432,68)" />
        <path clip-rule="evenodd" d="M 19 383v 98h 98v -98zM 33 397h 70v 70h -70z" transform="rotate(-90,68,432)" />
        <rect x="47" y="411" width="42" height="42" transform="rotate(-90,68,432)" />
      </clipPath>
    </defs>
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-background-color')" fill="#fff" />
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-dot-color')" fill="#000000" />
  </svg>
  <svg
    v-else-if="qr_version === 'test'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`"
  >
    <defs>
      <clipPath id="clip-path-dot-color">
        <rect x="19" y="145" width="14" height="14" transform="rotate(0,26,152)" />
        <rect x="19" y="159" width="14" height="14" transform="rotate(0,26,166)" />
        <rect x="19" y="173" width="14" height="14" transform="rotate(0,26,180)" />
        <rect x="19" y="187" width="14" height="14" transform="rotate(0,26,194)" />
        <rect x="19" y="201" width="14" height="14" transform="rotate(0,26,208)" />
        <rect x="19" y="215" width="14" height="14" transform="rotate(0,26,222)" />
        <rect x="19" y="229" width="14" height="14" transform="rotate(0,26,236)" />
        <rect x="19" y="243" width="14" height="14" transform="rotate(0,26,250)" />
        <rect x="19" y="257" width="14" height="14" transform="rotate(0,26,264)" />
        <rect x="19" y="271" width="14" height="14" transform="rotate(0,26,278)" />
        <rect x="19" y="285" width="14" height="14" transform="rotate(0,26,292)" />
        <rect x="19" y="299" width="14" height="14" transform="rotate(0,26,306)" />
        <rect x="19" y="313" width="14" height="14" transform="rotate(0,26,320)" />
        <rect x="19" y="341" width="14" height="14" transform="rotate(0,26,348)" />
        <rect x="19" y="355" width="14" height="14" transform="rotate(0,26,362)" />
        <rect x="33" y="131" width="14" height="14" transform="rotate(0,40,138)" />
        <rect x="33" y="145" width="14" height="14" transform="rotate(0,40,152)" />
        <rect x="33" y="187" width="14" height="14" transform="rotate(0,40,194)" />
        <rect x="33" y="201" width="14" height="14" transform="rotate(0,40,208)" />
        <rect x="33" y="215" width="14" height="14" transform="rotate(0,40,222)" />
        <rect x="33" y="271" width="14" height="14" transform="rotate(0,40,278)" />
        <rect x="33" y="313" width="14" height="14" transform="rotate(0,40,320)" />
        <rect x="33" y="341" width="14" height="14" transform="rotate(0,40,348)" />
        <rect x="33" y="355" width="14" height="14" transform="rotate(0,40,362)" />
        <rect x="47" y="131" width="14" height="14" transform="rotate(0,54,138)" />
        <rect x="47" y="187" width="14" height="14" transform="rotate(0,54,194)" />
        <rect x="47" y="215" width="14" height="14" transform="rotate(0,54,222)" />
        <rect x="47" y="243" width="14" height="14" transform="rotate(0,54,250)" />
        <rect x="47" y="257" width="14" height="14" transform="rotate(0,54,264)" />
        <rect x="47" y="299" width="14" height="14" transform="rotate(0,54,306)" />
        <rect x="47" y="327" width="14" height="14" transform="rotate(0,54,334)" />
        <rect x="61" y="173" width="14" height="14" transform="rotate(0,68,180)" />
        <rect x="61" y="215" width="14" height="14" transform="rotate(0,68,222)" />
        <rect x="61" y="285" width="14" height="14" transform="rotate(0,68,292)" />
        <rect x="61" y="327" width="14" height="14" transform="rotate(0,68,334)" />
        <rect x="61" y="355" width="14" height="14" transform="rotate(0,68,362)" />
        <rect x="75" y="173" width="14" height="14" transform="rotate(0,82,180)" />
        <rect x="75" y="201" width="14" height="14" transform="rotate(0,82,208)" />
        <rect x="75" y="215" width="14" height="14" transform="rotate(0,82,222)" />
        <rect x="75" y="229" width="14" height="14" transform="rotate(0,82,236)" />
        <rect x="75" y="257" width="14" height="14" transform="rotate(0,82,264)" />
        <rect x="75" y="299" width="14" height="14" transform="rotate(0,82,306)" />
        <rect x="75" y="313" width="14" height="14" transform="rotate(0,82,320)" />
        <rect x="75" y="355" width="14" height="14" transform="rotate(0,82,362)" />
        <rect x="89" y="145" width="14" height="14" transform="rotate(0,96,152)" />
        <rect x="89" y="159" width="14" height="14" transform="rotate(0,96,166)" />
        <rect x="89" y="173" width="14" height="14" transform="rotate(0,96,180)" />
        <rect x="89" y="201" width="14" height="14" transform="rotate(0,96,208)" />
        <rect x="89" y="215" width="14" height="14" transform="rotate(0,96,222)" />
        <rect x="89" y="229" width="14" height="14" transform="rotate(0,96,236)" />
        <rect x="89" y="243" width="14" height="14" transform="rotate(0,96,250)" />
        <rect x="89" y="285" width="14" height="14" transform="rotate(0,96,292)" />
        <rect x="89" y="313" width="14" height="14" transform="rotate(0,96,320)" />
        <rect x="89" y="355" width="14" height="14" transform="rotate(0,96,362)" />
        <rect x="103" y="131" width="14" height="14" transform="rotate(0,110,138)" />
        <rect x="103" y="159" width="14" height="14" transform="rotate(0,110,166)" />
        <rect x="103" y="187" width="14" height="14" transform="rotate(0,110,194)" />
        <rect x="103" y="215" width="14" height="14" transform="rotate(0,110,222)" />
        <rect x="103" y="243" width="14" height="14" transform="rotate(0,110,250)" />
        <rect x="103" y="271" width="14" height="14" transform="rotate(0,110,278)" />
        <rect x="103" y="299" width="14" height="14" transform="rotate(0,110,306)" />
        <rect x="103" y="327" width="14" height="14" transform="rotate(0,110,334)" />
        <rect x="103" y="355" width="14" height="14" transform="rotate(0,110,362)" />
        <rect x="117" y="159" width="14" height="14" transform="rotate(0,124,166)" />
        <rect x="117" y="187" width="14" height="14" transform="rotate(0,124,194)" />
        <rect x="117" y="229" width="14" height="14" transform="rotate(0,124,236)" />
        <rect x="117" y="243" width="14" height="14" transform="rotate(0,124,250)" />
        <rect x="117" y="257" width="14" height="14" transform="rotate(0,124,264)" />
        <rect x="117" y="271" width="14" height="14" transform="rotate(0,124,278)" />
        <rect x="117" y="299" width="14" height="14" transform="rotate(0,124,306)" />
        <rect x="117" y="355" width="14" height="14" transform="rotate(0,124,362)" />
        <rect x="131" y="33" width="14" height="14" transform="rotate(0,138,40)" />
        <rect x="131" y="47" width="14" height="14" transform="rotate(0,138,54)" />
        <rect x="131" y="61" width="14" height="14" transform="rotate(0,138,68)" />
        <rect x="131" y="89" width="14" height="14" transform="rotate(0,138,96)" />
        <rect x="131" y="103" width="14" height="14" transform="rotate(0,138,110)" />
        <rect x="131" y="159" width="14" height="14" transform="rotate(0,138,166)" />
        <rect x="131" y="201" width="14" height="14" transform="rotate(0,138,208)" />
        <rect x="131" y="229" width="14" height="14" transform="rotate(0,138,236)" />
        <rect x="131" y="257" width="14" height="14" transform="rotate(0,138,264)" />
        <rect x="131" y="271" width="14" height="14" transform="rotate(0,138,278)" />
        <rect x="131" y="285" width="14" height="14" transform="rotate(0,138,292)" />
        <rect x="131" y="313" width="14" height="14" transform="rotate(0,138,320)" />
        <rect x="131" y="341" width="14" height="14" transform="rotate(0,138,348)" />
        <rect x="131" y="355" width="14" height="14" transform="rotate(0,138,362)" />
        <rect x="131" y="439" width="14" height="14" transform="rotate(0,138,446)" />
        <rect x="131" y="453" width="14" height="14" transform="rotate(0,138,460)" />
        <rect x="145" y="33" width="14" height="14" transform="rotate(0,152,40)" />
        <rect x="145" y="47" width="14" height="14" transform="rotate(0,152,54)" />
        <rect x="145" y="61" width="14" height="14" transform="rotate(0,152,68)" />
        <rect x="145" y="89" width="14" height="14" transform="rotate(0,152,96)" />
        <rect x="145" y="117" width="14" height="14" transform="rotate(0,152,124)" />
        <rect x="145" y="131" width="14" height="14" transform="rotate(0,152,138)" />
        <rect x="145" y="145" width="14" height="14" transform="rotate(0,152,152)" />
        <rect x="145" y="159" width="14" height="14" transform="rotate(0,152,166)" />
        <rect x="145" y="201" width="14" height="14" transform="rotate(0,152,208)" />
        <rect x="145" y="229" width="14" height="14" transform="rotate(0,152,236)" />
        <rect x="145" y="243" width="14" height="14" transform="rotate(0,152,250)" />
        <rect x="145" y="271" width="14" height="14" transform="rotate(0,152,278)" />
        <rect x="145" y="285" width="14" height="14" transform="rotate(0,152,292)" />
        <rect x="145" y="299" width="14" height="14" transform="rotate(0,152,306)" />
        <rect x="145" y="341" width="14" height="14" transform="rotate(0,152,348)" />
        <rect x="145" y="355" width="14" height="14" transform="rotate(0,152,362)" />
        <rect x="145" y="383" width="14" height="14" transform="rotate(0,152,390)" />
        <rect x="145" y="397" width="14" height="14" transform="rotate(0,152,404)" />
        <rect x="145" y="425" width="14" height="14" transform="rotate(0,152,432)" />
        <rect x="145" y="439" width="14" height="14" transform="rotate(0,152,446)" />
        <rect x="145" y="453" width="14" height="14" transform="rotate(0,152,460)" />
        <rect x="145" y="467" width="14" height="14" transform="rotate(0,152,474)" />
        <rect x="159" y="19" width="14" height="14" transform="rotate(0,166,26)" />
        <rect x="159" y="47" width="14" height="14" transform="rotate(0,166,54)" />
        <rect x="159" y="61" width="14" height="14" transform="rotate(0,166,68)" />
        <rect x="159" y="103" width="14" height="14" transform="rotate(0,166,110)" />
        <rect x="159" y="131" width="14" height="14" transform="rotate(0,166,138)" />
        <rect x="159" y="201" width="14" height="14" transform="rotate(0,166,208)" />
        <rect x="159" y="243" width="14" height="14" transform="rotate(0,166,250)" />
        <rect x="159" y="257" width="14" height="14" transform="rotate(0,166,264)" />
        <rect x="159" y="299" width="14" height="14" transform="rotate(0,166,306)" />
        <rect x="159" y="341" width="14" height="14" transform="rotate(0,166,348)" />
        <rect x="159" y="369" width="14" height="14" transform="rotate(0,166,376)" />
        <rect x="159" y="397" width="14" height="14" transform="rotate(0,166,404)" />
        <rect x="159" y="411" width="14" height="14" transform="rotate(0,166,418)" />
        <rect x="159" y="425" width="14" height="14" transform="rotate(0,166,432)" />
        <rect x="159" y="453" width="14" height="14" transform="rotate(0,166,460)" />
        <rect x="159" y="467" width="14" height="14" transform="rotate(0,166,474)" />
        <rect x="173" y="19" width="14" height="14" transform="rotate(0,180,26)" />
        <rect x="173" y="47" width="14" height="14" transform="rotate(0,180,54)" />
        <rect x="173" y="75" width="14" height="14" transform="rotate(0,180,82)" />
        <rect x="173" y="89" width="14" height="14" transform="rotate(0,180,96)" />
        <rect x="173" y="117" width="14" height="14" transform="rotate(0,180,124)" />
        <rect x="173" y="131" width="14" height="14" transform="rotate(0,180,138)" />
        <rect x="173" y="145" width="14" height="14" transform="rotate(0,180,152)" />
        <rect x="173" y="159" width="14" height="14" transform="rotate(0,180,166)" />
        <rect x="173" y="187" width="14" height="14" transform="rotate(0,180,194)" />
        <rect x="173" y="215" width="14" height="14" transform="rotate(0,180,222)" />
        <rect x="173" y="229" width="14" height="14" transform="rotate(0,180,236)" />
        <rect x="173" y="243" width="14" height="14" transform="rotate(0,180,250)" />
        <rect x="173" y="271" width="14" height="14" transform="rotate(0,180,278)" />
        <rect x="173" y="355" width="14" height="14" transform="rotate(0,180,362)" />
        <rect x="173" y="397" width="14" height="14" transform="rotate(0,180,404)" />
        <rect x="173" y="425" width="14" height="14" transform="rotate(0,180,432)" />
        <rect x="187" y="47" width="14" height="14" transform="rotate(0,194,54)" />
        <rect x="187" y="75" width="14" height="14" transform="rotate(0,194,82)" />
        <rect x="187" y="103" width="14" height="14" transform="rotate(0,194,110)" />
        <rect x="187" y="131" width="14" height="14" transform="rotate(0,194,138)" />
        <rect x="187" y="145" width="14" height="14" transform="rotate(0,194,152)" />
        <rect x="187" y="159" width="14" height="14" transform="rotate(0,194,166)" />
        <rect x="187" y="201" width="14" height="14" transform="rotate(0,194,208)" />
        <rect x="187" y="243" width="14" height="14" transform="rotate(0,194,250)" />
        <rect x="187" y="271" width="14" height="14" transform="rotate(0,194,278)" />
        <rect x="187" y="299" width="14" height="14" transform="rotate(0,194,306)" />
        <rect x="187" y="327" width="14" height="14" transform="rotate(0,194,334)" />
        <rect x="187" y="355" width="14" height="14" transform="rotate(0,194,362)" />
        <rect x="187" y="369" width="14" height="14" transform="rotate(0,194,376)" />
        <rect x="187" y="397" width="14" height="14" transform="rotate(0,194,404)" />
        <rect x="187" y="411" width="14" height="14" transform="rotate(0,194,418)" />
        <rect x="187" y="425" width="14" height="14" transform="rotate(0,194,432)" />
        <rect x="201" y="33" width="14" height="14" transform="rotate(0,208,40)" />
        <rect x="201" y="61" width="14" height="14" transform="rotate(0,208,68)" />
        <rect x="201" y="75" width="14" height="14" transform="rotate(0,208,82)" />
        <rect x="201" y="117" width="14" height="14" transform="rotate(0,208,124)" />
        <rect x="201" y="187" width="14" height="14" transform="rotate(0,208,194)" />
        <rect x="201" y="229" width="14" height="14" transform="rotate(0,208,236)" />
        <rect x="201" y="243" width="14" height="14" transform="rotate(0,208,250)" />
        <rect x="201" y="257" width="14" height="14" transform="rotate(0,208,264)" />
        <rect x="201" y="271" width="14" height="14" transform="rotate(0,208,278)" />
        <rect x="201" y="285" width="14" height="14" transform="rotate(0,208,292)" />
        <rect x="201" y="355" width="14" height="14" transform="rotate(0,208,362)" />
        <rect x="201" y="369" width="14" height="14" transform="rotate(0,208,376)" />
        <rect x="201" y="425" width="14" height="14" transform="rotate(0,208,432)" />
        <rect x="201" y="453" width="14" height="14" transform="rotate(0,208,460)" />
        <rect x="215" y="33" width="14" height="14" transform="rotate(0,222,40)" />
        <rect x="215" y="47" width="14" height="14" transform="rotate(0,222,54)" />
        <rect x="215" y="75" width="14" height="14" transform="rotate(0,222,82)" />
        <rect x="215" y="103" width="14" height="14" transform="rotate(0,222,110)" />
        <rect x="215" y="117" width="14" height="14" transform="rotate(0,222,124)" />
        <rect x="215" y="145" width="14" height="14" transform="rotate(0,222,152)" />
        <rect x="215" y="187" width="14" height="14" transform="rotate(0,222,194)" />
        <rect x="215" y="229" width="14" height="14" transform="rotate(0,222,236)" />
        <rect x="215" y="243" width="14" height="14" transform="rotate(0,222,250)" />
        <rect x="215" y="257" width="14" height="14" transform="rotate(0,222,264)" />
        <rect x="215" y="285" width="14" height="14" transform="rotate(0,222,292)" />
        <rect x="215" y="327" width="14" height="14" transform="rotate(0,222,334)" />
        <rect x="215" y="355" width="14" height="14" transform="rotate(0,222,362)" />
        <rect x="215" y="383" width="14" height="14" transform="rotate(0,222,390)" />
        <rect x="215" y="397" width="14" height="14" transform="rotate(0,222,404)" />
        <rect x="229" y="19" width="14" height="14" transform="rotate(0,236,26)" />
        <rect x="229" y="61" width="14" height="14" transform="rotate(0,236,68)" />
        <rect x="229" y="75" width="14" height="14" transform="rotate(0,236,82)" />
        <rect x="229" y="187" width="14" height="14" transform="rotate(0,236,194)" />
        <rect x="229" y="243" width="14" height="14" transform="rotate(0,236,250)" />
        <rect x="229" y="257" width="14" height="14" transform="rotate(0,236,264)" />
        <rect x="229" y="271" width="14" height="14" transform="rotate(0,236,278)" />
        <rect x="229" y="313" width="14" height="14" transform="rotate(0,236,320)" />
        <rect x="229" y="327" width="14" height="14" transform="rotate(0,236,334)" />
        <rect x="229" y="369" width="14" height="14" transform="rotate(0,236,376)" />
        <rect x="229" y="383" width="14" height="14" transform="rotate(0,236,390)" />
        <rect x="229" y="411" width="14" height="14" transform="rotate(0,236,418)" />
        <rect x="229" y="425" width="14" height="14" transform="rotate(0,236,432)" />
        <rect x="229" y="439" width="14" height="14" transform="rotate(0,236,446)" />
        <rect x="243" y="19" width="14" height="14" transform="rotate(0,250,26)" />
        <rect x="243" y="33" width="14" height="14" transform="rotate(0,250,40)" />
        <rect x="243" y="47" width="14" height="14" transform="rotate(0,250,54)" />
        <rect x="243" y="75" width="14" height="14" transform="rotate(0,250,82)" />
        <rect x="243" y="103" width="14" height="14" transform="rotate(0,250,110)" />
        <rect x="243" y="131" width="14" height="14" transform="rotate(0,250,138)" />
        <rect x="243" y="159" width="14" height="14" transform="rotate(0,250,166)" />
        <rect x="243" y="173" width="14" height="14" transform="rotate(0,250,180)" />
        <rect x="243" y="201" width="14" height="14" transform="rotate(0,250,208)" />
        <rect x="243" y="257" width="14" height="14" transform="rotate(0,250,264)" />
        <rect x="243" y="313" width="14" height="14" transform="rotate(0,250,320)" />
        <rect x="243" y="327" width="14" height="14" transform="rotate(0,250,334)" />
        <rect x="243" y="355" width="14" height="14" transform="rotate(0,250,362)" />
        <rect x="243" y="369" width="14" height="14" transform="rotate(0,250,376)" />
        <rect x="243" y="383" width="14" height="14" transform="rotate(0,250,390)" />
        <rect x="243" y="411" width="14" height="14" transform="rotate(0,250,418)" />
        <rect x="243" y="439" width="14" height="14" transform="rotate(0,250,446)" />
        <rect x="257" y="19" width="14" height="14" transform="rotate(0,264,26)" />
        <rect x="257" y="47" width="14" height="14" transform="rotate(0,264,54)" />
        <rect x="257" y="61" width="14" height="14" transform="rotate(0,264,68)" />
        <rect x="257" y="89" width="14" height="14" transform="rotate(0,264,96)" />
        <rect x="257" y="117" width="14" height="14" transform="rotate(0,264,124)" />
        <rect x="257" y="159" width="14" height="14" transform="rotate(0,264,166)" />
        <rect x="257" y="299" width="14" height="14" transform="rotate(0,264,306)" />
        <rect x="257" y="313" width="14" height="14" transform="rotate(0,264,320)" />
        <rect x="257" y="341" width="14" height="14" transform="rotate(0,264,348)" />
        <rect x="257" y="355" width="14" height="14" transform="rotate(0,264,362)" />
        <rect x="257" y="383" width="14" height="14" transform="rotate(0,264,390)" />
        <rect x="257" y="411" width="14" height="14" transform="rotate(0,264,418)" />
        <rect x="257" y="425" width="14" height="14" transform="rotate(0,264,432)" />
        <rect x="257" y="453" width="14" height="14" transform="rotate(0,264,460)" />
        <rect x="257" y="467" width="14" height="14" transform="rotate(0,264,474)" />
        <rect x="271" y="19" width="14" height="14" transform="rotate(0,278,26)" />
        <rect x="271" y="33" width="14" height="14" transform="rotate(0,278,40)" />
        <rect x="271" y="47" width="14" height="14" transform="rotate(0,278,54)" />
        <rect x="271" y="61" width="14" height="14" transform="rotate(0,278,68)" />
        <rect x="271" y="75" width="14" height="14" transform="rotate(0,278,82)" />
        <rect x="271" y="89" width="14" height="14" transform="rotate(0,278,96)" />
        <rect x="271" y="103" width="14" height="14" transform="rotate(0,278,110)" />
        <rect x="271" y="131" width="14" height="14" transform="rotate(0,278,138)" />
        <rect x="271" y="187" width="14" height="14" transform="rotate(0,278,194)" />
        <rect x="271" y="201" width="14" height="14" transform="rotate(0,278,208)" />
        <rect x="271" y="215" width="14" height="14" transform="rotate(0,278,222)" />
        <rect x="271" y="229" width="14" height="14" transform="rotate(0,278,236)" />
        <rect x="271" y="243" width="14" height="14" transform="rotate(0,278,250)" />
        <rect x="271" y="257" width="14" height="14" transform="rotate(0,278,264)" />
        <rect x="271" y="313" width="14" height="14" transform="rotate(0,278,320)" />
        <rect x="271" y="327" width="14" height="14" transform="rotate(0,278,334)" />
        <rect x="271" y="369" width="14" height="14" transform="rotate(0,278,376)" />
        <rect x="271" y="397" width="14" height="14" transform="rotate(0,278,404)" />
        <rect x="271" y="411" width="14" height="14" transform="rotate(0,278,418)" />
        <rect x="271" y="439" width="14" height="14" transform="rotate(0,278,446)" />
        <rect x="271" y="453" width="14" height="14" transform="rotate(0,278,460)" />
        <rect x="285" y="19" width="14" height="14" transform="rotate(0,292,26)" />
        <rect x="285" y="47" width="14" height="14" transform="rotate(0,292,54)" />
        <rect x="285" y="61" width="14" height="14" transform="rotate(0,292,68)" />
        <rect x="285" y="131" width="14" height="14" transform="rotate(0,292,138)" />
        <rect x="285" y="159" width="14" height="14" transform="rotate(0,292,166)" />
        <rect x="285" y="187" width="14" height="14" transform="rotate(0,292,194)" />
        <rect x="285" y="215" width="14" height="14" transform="rotate(0,292,222)" />
        <rect x="285" y="229" width="14" height="14" transform="rotate(0,292,236)" />
        <rect x="285" y="271" width="14" height="14" transform="rotate(0,292,278)" />
        <rect x="285" y="285" width="14" height="14" transform="rotate(0,292,292)" />
        <rect x="285" y="299" width="14" height="14" transform="rotate(0,292,306)" />
        <rect x="285" y="383" width="14" height="14" transform="rotate(0,292,390)" />
        <rect x="285" y="411" width="14" height="14" transform="rotate(0,292,418)" />
        <rect x="299" y="33" width="14" height="14" transform="rotate(0,306,40)" />
        <rect x="299" y="47" width="14" height="14" transform="rotate(0,306,54)" />
        <rect x="299" y="103" width="14" height="14" transform="rotate(0,306,110)" />
        <rect x="299" y="117" width="14" height="14" transform="rotate(0,306,124)" />
        <rect x="299" y="159" width="14" height="14" transform="rotate(0,306,166)" />
        <rect x="299" y="173" width="14" height="14" transform="rotate(0,306,180)" />
        <rect x="299" y="187" width="14" height="14" transform="rotate(0,306,194)" />
        <rect x="299" y="201" width="14" height="14" transform="rotate(0,306,208)" />
        <rect x="299" y="215" width="14" height="14" transform="rotate(0,306,222)" />
        <rect x="299" y="285" width="14" height="14" transform="rotate(0,306,292)" />
        <rect x="299" y="299" width="14" height="14" transform="rotate(0,306,306)" />
        <rect x="299" y="313" width="14" height="14" transform="rotate(0,306,320)" />
        <rect x="299" y="425" width="14" height="14" transform="rotate(0,306,432)" />
        <rect x="299" y="439" width="14" height="14" transform="rotate(0,306,446)" />
        <rect x="299" y="467" width="14" height="14" transform="rotate(0,306,474)" />
        <rect x="313" y="19" width="14" height="14" transform="rotate(0,320,26)" />
        <rect x="313" y="47" width="14" height="14" transform="rotate(0,320,54)" />
        <rect x="313" y="75" width="14" height="14" transform="rotate(0,320,82)" />
        <rect x="313" y="117" width="14" height="14" transform="rotate(0,320,124)" />
        <rect x="313" y="131" width="14" height="14" transform="rotate(0,320,138)" />
        <rect x="313" y="145" width="14" height="14" transform="rotate(0,320,152)" />
        <rect x="313" y="173" width="14" height="14" transform="rotate(0,320,180)" />
        <rect x="313" y="187" width="14" height="14" transform="rotate(0,320,194)" />
        <rect x="313" y="215" width="14" height="14" transform="rotate(0,320,222)" />
        <rect x="313" y="243" width="14" height="14" transform="rotate(0,320,250)" />
        <rect x="313" y="257" width="14" height="14" transform="rotate(0,320,264)" />
        <rect x="313" y="271" width="14" height="14" transform="rotate(0,320,278)" />
        <rect x="313" y="285" width="14" height="14" transform="rotate(0,320,292)" />
        <rect x="313" y="299" width="14" height="14" transform="rotate(0,320,306)" />
        <rect x="313" y="313" width="14" height="14" transform="rotate(0,320,320)" />
        <rect x="313" y="341" width="14" height="14" transform="rotate(0,320,348)" />
        <rect x="313" y="383" width="14" height="14" transform="rotate(0,320,390)" />
        <rect x="313" y="439" width="14" height="14" transform="rotate(0,320,446)" />
        <rect x="313" y="467" width="14" height="14" transform="rotate(0,320,474)" />
        <rect x="327" y="47" width="14" height="14" transform="rotate(0,334,54)" />
        <rect x="327" y="61" width="14" height="14" transform="rotate(0,334,68)" />
        <rect x="327" y="75" width="14" height="14" transform="rotate(0,334,82)" />
        <rect x="327" y="89" width="14" height="14" transform="rotate(0,334,96)" />
        <rect x="327" y="103" width="14" height="14" transform="rotate(0,334,110)" />
        <rect x="327" y="131" width="14" height="14" transform="rotate(0,334,138)" />
        <rect x="327" y="159" width="14" height="14" transform="rotate(0,334,166)" />
        <rect x="327" y="173" width="14" height="14" transform="rotate(0,334,180)" />
        <rect x="327" y="201" width="14" height="14" transform="rotate(0,334,208)" />
        <rect x="327" y="341" width="14" height="14" transform="rotate(0,334,348)" />
        <rect x="327" y="355" width="14" height="14" transform="rotate(0,334,362)" />
        <rect x="327" y="369" width="14" height="14" transform="rotate(0,334,376)" />
        <rect x="327" y="383" width="14" height="14" transform="rotate(0,334,390)" />
        <rect x="327" y="397" width="14" height="14" transform="rotate(0,334,404)" />
        <rect x="327" y="411" width="14" height="14" transform="rotate(0,334,418)" />
        <rect x="327" y="425" width="14" height="14" transform="rotate(0,334,432)" />
        <rect x="327" y="453" width="14" height="14" transform="rotate(0,334,460)" />
        <rect x="327" y="467" width="14" height="14" transform="rotate(0,334,474)" />
        <rect x="341" y="33" width="14" height="14" transform="rotate(0,348,40)" />
        <rect x="341" y="61" width="14" height="14" transform="rotate(0,348,68)" />
        <rect x="341" y="117" width="14" height="14" transform="rotate(0,348,124)" />
        <rect x="341" y="131" width="14" height="14" transform="rotate(0,348,138)" />
        <rect x="341" y="145" width="14" height="14" transform="rotate(0,348,152)" />
        <rect x="341" y="173" width="14" height="14" transform="rotate(0,348,180)" />
        <rect x="341" y="229" width="14" height="14" transform="rotate(0,348,236)" />
        <rect x="341" y="243" width="14" height="14" transform="rotate(0,348,250)" />
        <rect x="341" y="285" width="14" height="14" transform="rotate(0,348,292)" />
        <rect x="341" y="327" width="14" height="14" transform="rotate(0,348,334)" />
        <rect x="341" y="355" width="14" height="14" transform="rotate(0,348,362)" />
        <rect x="341" y="369" width="14" height="14" transform="rotate(0,348,376)" />
        <rect x="341" y="397" width="14" height="14" transform="rotate(0,348,404)" />
        <rect x="341" y="411" width="14" height="14" transform="rotate(0,348,418)" />
        <rect x="341" y="453" width="14" height="14" transform="rotate(0,348,460)" />
        <rect x="355" y="19" width="14" height="14" transform="rotate(0,362,26)" />
        <rect x="355" y="47" width="14" height="14" transform="rotate(0,362,54)" />
        <rect x="355" y="61" width="14" height="14" transform="rotate(0,362,68)" />
        <rect x="355" y="89" width="14" height="14" transform="rotate(0,362,96)" />
        <rect x="355" y="103" width="14" height="14" transform="rotate(0,362,110)" />
        <rect x="355" y="131" width="14" height="14" transform="rotate(0,362,138)" />
        <rect x="355" y="145" width="14" height="14" transform="rotate(0,362,152)" />
        <rect x="355" y="187" width="14" height="14" transform="rotate(0,362,194)" />
        <rect x="355" y="201" width="14" height="14" transform="rotate(0,362,208)" />
        <rect x="355" y="243" width="14" height="14" transform="rotate(0,362,250)" />
        <rect x="355" y="257" width="14" height="14" transform="rotate(0,362,264)" />
        <rect x="355" y="271" width="14" height="14" transform="rotate(0,362,278)" />
        <rect x="355" y="327" width="14" height="14" transform="rotate(0,362,334)" />
        <rect x="355" y="341" width="14" height="14" transform="rotate(0,362,348)" />
        <rect x="355" y="355" width="14" height="14" transform="rotate(0,362,362)" />
        <rect x="355" y="369" width="14" height="14" transform="rotate(0,362,376)" />
        <rect x="355" y="383" width="14" height="14" transform="rotate(0,362,390)" />
        <rect x="355" y="397" width="14" height="14" transform="rotate(0,362,404)" />
        <rect x="355" y="411" width="14" height="14" transform="rotate(0,362,418)" />
        <rect x="355" y="453" width="14" height="14" transform="rotate(0,362,460)" />
        <rect x="355" y="467" width="14" height="14" transform="rotate(0,362,474)" />
        <rect x="369" y="131" width="14" height="14" transform="rotate(0,376,138)" />
        <rect x="369" y="145" width="14" height="14" transform="rotate(0,376,152)" />
        <rect x="369" y="159" width="14" height="14" transform="rotate(0,376,166)" />
        <rect x="369" y="187" width="14" height="14" transform="rotate(0,376,194)" />
        <rect x="369" y="257" width="14" height="14" transform="rotate(0,376,264)" />
        <rect x="369" y="285" width="14" height="14" transform="rotate(0,376,292)" />
        <rect x="369" y="355" width="14" height="14" transform="rotate(0,376,362)" />
        <rect x="369" y="411" width="14" height="14" transform="rotate(0,376,418)" />
        <rect x="369" y="425" width="14" height="14" transform="rotate(0,376,432)" />
        <rect x="383" y="145" width="14" height="14" transform="rotate(0,390,152)" />
        <rect x="383" y="159" width="14" height="14" transform="rotate(0,390,166)" />
        <rect x="383" y="187" width="14" height="14" transform="rotate(0,390,194)" />
        <rect x="383" y="215" width="14" height="14" transform="rotate(0,390,222)" />
        <rect x="383" y="257" width="14" height="14" transform="rotate(0,390,264)" />
        <rect x="383" y="285" width="14" height="14" transform="rotate(0,390,292)" />
        <rect x="383" y="299" width="14" height="14" transform="rotate(0,390,306)" />
        <rect x="383" y="341" width="14" height="14" transform="rotate(0,390,348)" />
        <rect x="383" y="355" width="14" height="14" transform="rotate(0,390,362)" />
        <rect x="383" y="383" width="14" height="14" transform="rotate(0,390,390)" />
        <rect x="383" y="411" width="14" height="14" transform="rotate(0,390,418)" />
        <rect x="383" y="453" width="14" height="14" transform="rotate(0,390,460)" />
        <rect x="397" y="131" width="14" height="14" transform="rotate(0,404,138)" />
        <rect x="397" y="159" width="14" height="14" transform="rotate(0,404,166)" />
        <rect x="397" y="187" width="14" height="14" transform="rotate(0,404,194)" />
        <rect x="397" y="215" width="14" height="14" transform="rotate(0,404,222)" />
        <rect x="397" y="229" width="14" height="14" transform="rotate(0,404,236)" />
        <rect x="397" y="243" width="14" height="14" transform="rotate(0,404,250)" />
        <rect x="397" y="313" width="14" height="14" transform="rotate(0,404,320)" />
        <rect x="397" y="327" width="14" height="14" transform="rotate(0,404,334)" />
        <rect x="397" y="341" width="14" height="14" transform="rotate(0,404,348)" />
        <rect x="397" y="355" width="14" height="14" transform="rotate(0,404,362)" />
        <rect x="397" y="411" width="14" height="14" transform="rotate(0,404,418)" />
        <rect x="397" y="425" width="14" height="14" transform="rotate(0,404,432)" />
        <rect x="397" y="439" width="14" height="14" transform="rotate(0,404,446)" />
        <rect x="411" y="145" width="14" height="14" transform="rotate(0,418,152)" />
        <rect x="411" y="173" width="14" height="14" transform="rotate(0,418,180)" />
        <rect x="411" y="201" width="14" height="14" transform="rotate(0,418,208)" />
        <rect x="411" y="215" width="14" height="14" transform="rotate(0,418,222)" />
        <rect x="411" y="229" width="14" height="14" transform="rotate(0,418,236)" />
        <rect x="411" y="243" width="14" height="14" transform="rotate(0,418,250)" />
        <rect x="411" y="257" width="14" height="14" transform="rotate(0,418,264)" />
        <rect x="411" y="299" width="14" height="14" transform="rotate(0,418,306)" />
        <rect x="411" y="313" width="14" height="14" transform="rotate(0,418,320)" />
        <rect x="411" y="341" width="14" height="14" transform="rotate(0,418,348)" />
        <rect x="411" y="355" width="14" height="14" transform="rotate(0,418,362)" />
        <rect x="411" y="369" width="14" height="14" transform="rotate(0,418,376)" />
        <rect x="411" y="383" width="14" height="14" transform="rotate(0,418,390)" />
        <rect x="411" y="397" width="14" height="14" transform="rotate(0,418,404)" />
        <rect x="411" y="411" width="14" height="14" transform="rotate(0,418,418)" />
        <rect x="411" y="439" width="14" height="14" transform="rotate(0,418,446)" />
        <rect x="411" y="453" width="14" height="14" transform="rotate(0,418,460)" />
        <rect x="411" y="467" width="14" height="14" transform="rotate(0,418,474)" />
        <rect x="425" y="131" width="14" height="14" transform="rotate(0,432,138)" />
        <rect x="425" y="145" width="14" height="14" transform="rotate(0,432,152)" />
        <rect x="425" y="159" width="14" height="14" transform="rotate(0,432,166)" />
        <rect x="425" y="173" width="14" height="14" transform="rotate(0,432,180)" />
        <rect x="425" y="201" width="14" height="14" transform="rotate(0,432,208)" />
        <rect x="425" y="215" width="14" height="14" transform="rotate(0,432,222)" />
        <rect x="425" y="271" width="14" height="14" transform="rotate(0,432,278)" />
        <rect x="425" y="299" width="14" height="14" transform="rotate(0,432,306)" />
        <rect x="425" y="313" width="14" height="14" transform="rotate(0,432,320)" />
        <rect x="425" y="327" width="14" height="14" transform="rotate(0,432,334)" />
        <rect x="425" y="341" width="14" height="14" transform="rotate(0,432,348)" />
        <rect x="425" y="397" width="14" height="14" transform="rotate(0,432,404)" />
        <rect x="425" y="425" width="14" height="14" transform="rotate(0,432,432)" />
        <rect x="425" y="439" width="14" height="14" transform="rotate(0,432,446)" />
        <rect x="425" y="453" width="14" height="14" transform="rotate(0,432,460)" />
        <rect x="425" y="467" width="14" height="14" transform="rotate(0,432,474)" />
        <rect x="439" y="131" width="14" height="14" transform="rotate(0,446,138)" />
        <rect x="439" y="145" width="14" height="14" transform="rotate(0,446,152)" />
        <rect x="439" y="159" width="14" height="14" transform="rotate(0,446,166)" />
        <rect x="439" y="229" width="14" height="14" transform="rotate(0,446,236)" />
        <rect x="439" y="271" width="14" height="14" transform="rotate(0,446,278)" />
        <rect x="439" y="299" width="14" height="14" transform="rotate(0,446,306)" />
        <rect x="439" y="313" width="14" height="14" transform="rotate(0,446,320)" />
        <rect x="439" y="341" width="14" height="14" transform="rotate(0,446,348)" />
        <rect x="439" y="355" width="14" height="14" transform="rotate(0,446,362)" />
        <rect x="439" y="383" width="14" height="14" transform="rotate(0,446,390)" />
        <rect x="439" y="397" width="14" height="14" transform="rotate(0,446,404)" />
        <rect x="439" y="425" width="14" height="14" transform="rotate(0,446,432)" />
        <rect x="453" y="131" width="14" height="14" transform="rotate(0,460,138)" />
        <rect x="453" y="173" width="14" height="14" transform="rotate(0,460,180)" />
        <rect x="453" y="187" width="14" height="14" transform="rotate(0,460,194)" />
        <rect x="453" y="215" width="14" height="14" transform="rotate(0,460,222)" />
        <rect x="453" y="271" width="14" height="14" transform="rotate(0,460,278)" />
        <rect x="453" y="327" width="14" height="14" transform="rotate(0,460,334)" />
        <rect x="453" y="341" width="14" height="14" transform="rotate(0,460,348)" />
        <rect x="453" y="355" width="14" height="14" transform="rotate(0,460,362)" />
        <rect x="453" y="369" width="14" height="14" transform="rotate(0,460,376)" />
        <rect x="453" y="397" width="14" height="14" transform="rotate(0,460,404)" />
        <rect x="453" y="411" width="14" height="14" transform="rotate(0,460,418)" />
        <rect x="453" y="467" width="14" height="14" transform="rotate(0,460,474)" />
        <rect x="467" y="145" width="14" height="14" transform="rotate(0,474,152)" />
        <rect x="467" y="159" width="14" height="14" transform="rotate(0,474,166)" />
        <rect x="467" y="313" width="14" height="14" transform="rotate(0,474,320)" />
        <rect x="467" y="383" width="14" height="14" transform="rotate(0,474,390)" />
        <rect x="467" y="411" width="14" height="14" transform="rotate(0,474,418)" />
        <rect x="467" y="439" width="14" height="14" transform="rotate(0,474,446)" />
        <path clip-rule="evenodd" d="M 19 19v 98h 98v -98zM 33 33h 70v 70h -70z" transform="rotate(0,68,68)" />
        <rect x="47" y="47" width="42" height="42" transform="rotate(0,68,68)" />
        <path clip-rule="evenodd" d="M 383 19v 98h 98v -98zM 397 33h 70v 70h -70z" transform="rotate(90,432,68)" />
        <rect x="411" y="47" width="42" height="42" transform="rotate(90,432,68)" />
        <path clip-rule="evenodd" d="M 19 383v 98h 98v -98zM 33 397h 70v 70h -70z" transform="rotate(-90,68,432)" />
        <rect x="47" y="411" width="42" height="42" transform="rotate(-90,68,432)" />
      </clipPath>
    </defs>
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-background-color')" fill="#fff" />
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-dot-color')" fill="#000000" />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${viewBoxWidth} ${viewBoxHeight}`"
  >
    <defs>
      <clipPath id="clip-path-dot-color">
        <rect x="19" y="159" width="14" height="14" transform="rotate(0,26,166)" />
        <rect x="19" y="173" width="14" height="14" transform="rotate(0,26,180)" />
        <rect x="19" y="201" width="14" height="14" transform="rotate(0,26,208)" />
        <rect x="19" y="229" width="14" height="14" transform="rotate(0,26,236)" />
        <rect x="19" y="243" width="14" height="14" transform="rotate(0,26,250)" />
        <rect x="19" y="271" width="14" height="14" transform="rotate(0,26,278)" />
        <rect x="19" y="299" width="14" height="14" transform="rotate(0,26,306)" />
        <rect x="19" y="313" width="14" height="14" transform="rotate(0,26,320)" />
        <rect x="19" y="355" width="14" height="14" transform="rotate(0,26,362)" />
        <rect x="33" y="131" width="14" height="14" transform="rotate(0,40,138)" />
        <rect x="33" y="145" width="14" height="14" transform="rotate(0,40,152)" />
        <rect x="33" y="159" width="14" height="14" transform="rotate(0,40,166)" />
        <rect x="33" y="173" width="14" height="14" transform="rotate(0,40,180)" />
        <rect x="33" y="187" width="14" height="14" transform="rotate(0,40,194)" />
        <rect x="33" y="215" width="14" height="14" transform="rotate(0,40,222)" />
        <rect x="33" y="243" width="14" height="14" transform="rotate(0,40,250)" />
        <rect x="33" y="257" width="14" height="14" transform="rotate(0,40,264)" />
        <rect x="33" y="285" width="14" height="14" transform="rotate(0,40,292)" />
        <rect x="33" y="355" width="14" height="14" transform="rotate(0,40,362)" />
        <rect x="47" y="145" width="14" height="14" transform="rotate(0,54,152)" />
        <rect x="47" y="187" width="14" height="14" transform="rotate(0,54,194)" />
        <rect x="47" y="215" width="14" height="14" transform="rotate(0,54,222)" />
        <rect x="47" y="257" width="14" height="14" transform="rotate(0,54,264)" />
        <rect x="47" y="271" width="14" height="14" transform="rotate(0,54,278)" />
        <rect x="47" y="285" width="14" height="14" transform="rotate(0,54,292)" />
        <rect x="47" y="313" width="14" height="14" transform="rotate(0,54,320)" />
        <rect x="47" y="327" width="14" height="14" transform="rotate(0,54,334)" />
        <rect x="47" y="341" width="14" height="14" transform="rotate(0,54,348)" />
        <rect x="61" y="131" width="14" height="14" transform="rotate(0,68,138)" />
        <rect x="61" y="201" width="14" height="14" transform="rotate(0,68,208)" />
        <rect x="61" y="215" width="14" height="14" transform="rotate(0,68,222)" />
        <rect x="61" y="229" width="14" height="14" transform="rotate(0,68,236)" />
        <rect x="61" y="313" width="14" height="14" transform="rotate(0,68,320)" />
        <rect x="61" y="341" width="14" height="14" transform="rotate(0,68,348)" />
        <rect x="75" y="131" width="14" height="14" transform="rotate(0,82,138)" />
        <rect x="75" y="145" width="14" height="14" transform="rotate(0,82,152)" />
        <rect x="75" y="201" width="14" height="14" transform="rotate(0,82,208)" />
        <rect x="75" y="215" width="14" height="14" transform="rotate(0,82,222)" />
        <rect x="75" y="229" width="14" height="14" transform="rotate(0,82,236)" />
        <rect x="75" y="271" width="14" height="14" transform="rotate(0,82,278)" />
        <rect x="75" y="299" width="14" height="14" transform="rotate(0,82,306)" />
        <rect x="75" y="313" width="14" height="14" transform="rotate(0,82,320)" />
        <rect x="75" y="327" width="14" height="14" transform="rotate(0,82,334)" />
        <rect x="89" y="145" width="14" height="14" transform="rotate(0,96,152)" />
        <rect x="89" y="173" width="14" height="14" transform="rotate(0,96,180)" />
        <rect x="89" y="187" width="14" height="14" transform="rotate(0,96,194)" />
        <rect x="89" y="243" width="14" height="14" transform="rotate(0,96,250)" />
        <rect x="89" y="299" width="14" height="14" transform="rotate(0,96,306)" />
        <rect x="89" y="327" width="14" height="14" transform="rotate(0,96,334)" />
        <rect x="89" y="341" width="14" height="14" transform="rotate(0,96,348)" />
        <rect x="103" y="131" width="14" height="14" transform="rotate(0,110,138)" />
        <rect x="103" y="159" width="14" height="14" transform="rotate(0,110,166)" />
        <rect x="103" y="187" width="14" height="14" transform="rotate(0,110,194)" />
        <rect x="103" y="215" width="14" height="14" transform="rotate(0,110,222)" />
        <rect x="103" y="243" width="14" height="14" transform="rotate(0,110,250)" />
        <rect x="103" y="271" width="14" height="14" transform="rotate(0,110,278)" />
        <rect x="103" y="299" width="14" height="14" transform="rotate(0,110,306)" />
        <rect x="103" y="327" width="14" height="14" transform="rotate(0,110,334)" />
        <rect x="103" y="355" width="14" height="14" transform="rotate(0,110,362)" />
        <rect x="117" y="131" width="14" height="14" transform="rotate(0,124,138)" />
        <rect x="117" y="145" width="14" height="14" transform="rotate(0,124,152)" />
        <rect x="117" y="215" width="14" height="14" transform="rotate(0,124,222)" />
        <rect x="117" y="229" width="14" height="14" transform="rotate(0,124,236)" />
        <rect x="117" y="285" width="14" height="14" transform="rotate(0,124,292)" />
        <rect x="117" y="299" width="14" height="14" transform="rotate(0,124,306)" />
        <rect x="117" y="355" width="14" height="14" transform="rotate(0,124,362)" />
        <rect x="131" y="33" width="14" height="14" transform="rotate(0,138,40)" />
        <rect x="131" y="61" width="14" height="14" transform="rotate(0,138,68)" />
        <rect x="131" y="75" width="14" height="14" transform="rotate(0,138,82)" />
        <rect x="131" y="89" width="14" height="14" transform="rotate(0,138,96)" />
        <rect x="131" y="103" width="14" height="14" transform="rotate(0,138,110)" />
        <rect x="131" y="131" width="14" height="14" transform="rotate(0,138,138)" />
        <rect x="131" y="145" width="14" height="14" transform="rotate(0,138,152)" />
        <rect x="131" y="159" width="14" height="14" transform="rotate(0,138,166)" />
        <rect x="131" y="173" width="14" height="14" transform="rotate(0,138,180)" />
        <rect x="131" y="187" width="14" height="14" transform="rotate(0,138,194)" />
        <rect x="131" y="201" width="14" height="14" transform="rotate(0,138,208)" />
        <rect x="131" y="243" width="14" height="14" transform="rotate(0,138,250)" />
        <rect x="131" y="257" width="14" height="14" transform="rotate(0,138,264)" />
        <rect x="131" y="285" width="14" height="14" transform="rotate(0,138,292)" />
        <rect x="131" y="299" width="14" height="14" transform="rotate(0,138,306)" />
        <rect x="131" y="327" width="14" height="14" transform="rotate(0,138,334)" />
        <rect x="131" y="355" width="14" height="14" transform="rotate(0,138,362)" />
        <rect x="131" y="369" width="14" height="14" transform="rotate(0,138,376)" />
        <rect x="131" y="383" width="14" height="14" transform="rotate(0,138,390)" />
        <rect x="131" y="411" width="14" height="14" transform="rotate(0,138,418)" />
        <rect x="131" y="425" width="14" height="14" transform="rotate(0,138,432)" />
        <rect x="131" y="453" width="14" height="14" transform="rotate(0,138,460)" />
        <rect x="145" y="33" width="14" height="14" transform="rotate(0,152,40)" />
        <rect x="145" y="47" width="14" height="14" transform="rotate(0,152,54)" />
        <rect x="145" y="243" width="14" height="14" transform="rotate(0,152,250)" />
        <rect x="145" y="271" width="14" height="14" transform="rotate(0,152,278)" />
        <rect x="145" y="285" width="14" height="14" transform="rotate(0,152,292)" />
        <rect x="145" y="299" width="14" height="14" transform="rotate(0,152,306)" />
        <rect x="145" y="327" width="14" height="14" transform="rotate(0,152,334)" />
        <rect x="145" y="341" width="14" height="14" transform="rotate(0,152,348)" />
        <rect x="145" y="355" width="14" height="14" transform="rotate(0,152,362)" />
        <rect x="145" y="369" width="14" height="14" transform="rotate(0,152,376)" />
        <rect x="145" y="411" width="14" height="14" transform="rotate(0,152,418)" />
        <rect x="145" y="425" width="14" height="14" transform="rotate(0,152,432)" />
        <rect x="145" y="439" width="14" height="14" transform="rotate(0,152,446)" />
        <rect x="145" y="453" width="14" height="14" transform="rotate(0,152,460)" />
        <rect x="159" y="19" width="14" height="14" transform="rotate(0,166,26)" />
        <rect x="159" y="33" width="14" height="14" transform="rotate(0,166,40)" />
        <rect x="159" y="47" width="14" height="14" transform="rotate(0,166,54)" />
        <rect x="159" y="61" width="14" height="14" transform="rotate(0,166,68)" />
        <rect x="159" y="103" width="14" height="14" transform="rotate(0,166,110)" />
        <rect x="159" y="117" width="14" height="14" transform="rotate(0,166,124)" />
        <rect x="159" y="131" width="14" height="14" transform="rotate(0,166,138)" />
        <rect x="159" y="173" width="14" height="14" transform="rotate(0,166,180)" />
        <rect x="159" y="187" width="14" height="14" transform="rotate(0,166,194)" />
        <rect x="159" y="215" width="14" height="14" transform="rotate(0,166,222)" />
        <rect x="159" y="257" width="14" height="14" transform="rotate(0,166,264)" />
        <rect x="159" y="271" width="14" height="14" transform="rotate(0,166,278)" />
        <rect x="159" y="299" width="14" height="14" transform="rotate(0,166,306)" />
        <rect x="159" y="313" width="14" height="14" transform="rotate(0,166,320)" />
        <rect x="159" y="341" width="14" height="14" transform="rotate(0,166,348)" />
        <rect x="159" y="355" width="14" height="14" transform="rotate(0,166,362)" />
        <rect x="159" y="383" width="14" height="14" transform="rotate(0,166,390)" />
        <rect x="159" y="411" width="14" height="14" transform="rotate(0,166,418)" />
        <rect x="159" y="425" width="14" height="14" transform="rotate(0,166,432)" />
        <rect x="159" y="439" width="14" height="14" transform="rotate(0,166,446)" />
        <rect x="159" y="453" width="14" height="14" transform="rotate(0,166,460)" />
        <rect x="159" y="467" width="14" height="14" transform="rotate(0,166,474)" />
        <rect x="173" y="19" width="14" height="14" transform="rotate(0,180,26)" />
        <rect x="173" y="47" width="14" height="14" transform="rotate(0,180,54)" />
        <rect x="173" y="61" width="14" height="14" transform="rotate(0,180,68)" />
        <rect x="173" y="89" width="14" height="14" transform="rotate(0,180,96)" />
        <rect x="173" y="117" width="14" height="14" transform="rotate(0,180,124)" />
        <rect x="173" y="173" width="14" height="14" transform="rotate(0,180,180)" />
        <rect x="173" y="201" width="14" height="14" transform="rotate(0,180,208)" />
        <rect x="173" y="243" width="14" height="14" transform="rotate(0,180,250)" />
        <rect x="173" y="257" width="14" height="14" transform="rotate(0,180,264)" />
        <rect x="173" y="327" width="14" height="14" transform="rotate(0,180,334)" />
        <rect x="173" y="341" width="14" height="14" transform="rotate(0,180,348)" />
        <rect x="173" y="355" width="14" height="14" transform="rotate(0,180,362)" />
        <rect x="173" y="383" width="14" height="14" transform="rotate(0,180,390)" />
        <rect x="173" y="397" width="14" height="14" transform="rotate(0,180,404)" />
        <rect x="173" y="439" width="14" height="14" transform="rotate(0,180,446)" />
        <rect x="173" y="453" width="14" height="14" transform="rotate(0,180,460)" />
        <rect x="187" y="47" width="14" height="14" transform="rotate(0,194,54)" />
        <rect x="187" y="61" width="14" height="14" transform="rotate(0,194,68)" />
        <rect x="187" y="103" width="14" height="14" transform="rotate(0,194,110)" />
        <rect x="187" y="131" width="14" height="14" transform="rotate(0,194,138)" />
        <rect x="187" y="159" width="14" height="14" transform="rotate(0,194,166)" />
        <rect x="187" y="187" width="14" height="14" transform="rotate(0,194,194)" />
        <rect x="187" y="201" width="14" height="14" transform="rotate(0,194,208)" />
        <rect x="187" y="229" width="14" height="14" transform="rotate(0,194,236)" />
        <rect x="187" y="257" width="14" height="14" transform="rotate(0,194,264)" />
        <rect x="187" y="271" width="14" height="14" transform="rotate(0,194,278)" />
        <rect x="187" y="299" width="14" height="14" transform="rotate(0,194,306)" />
        <rect x="187" y="313" width="14" height="14" transform="rotate(0,194,320)" />
        <rect x="187" y="327" width="14" height="14" transform="rotate(0,194,334)" />
        <rect x="187" y="341" width="14" height="14" transform="rotate(0,194,348)" />
        <rect x="187" y="355" width="14" height="14" transform="rotate(0,194,362)" />
        <rect x="187" y="383" width="14" height="14" transform="rotate(0,194,390)" />
        <rect x="187" y="397" width="14" height="14" transform="rotate(0,194,404)" />
        <rect x="201" y="61" width="14" height="14" transform="rotate(0,208,68)" />
        <rect x="201" y="75" width="14" height="14" transform="rotate(0,208,82)" />
        <rect x="201" y="89" width="14" height="14" transform="rotate(0,208,96)" />
        <rect x="201" y="117" width="14" height="14" transform="rotate(0,208,124)" />
        <rect x="201" y="145" width="14" height="14" transform="rotate(0,208,152)" />
        <rect x="201" y="159" width="14" height="14" transform="rotate(0,208,166)" />
        <rect x="201" y="215" width="14" height="14" transform="rotate(0,208,222)" />
        <rect x="201" y="229" width="14" height="14" transform="rotate(0,208,236)" />
        <rect x="201" y="243" width="14" height="14" transform="rotate(0,208,250)" />
        <rect x="201" y="285" width="14" height="14" transform="rotate(0,208,292)" />
        <rect x="201" y="313" width="14" height="14" transform="rotate(0,208,320)" />
        <rect x="201" y="341" width="14" height="14" transform="rotate(0,208,348)" />
        <rect x="201" y="369" width="14" height="14" transform="rotate(0,208,376)" />
        <rect x="201" y="397" width="14" height="14" transform="rotate(0,208,404)" />
        <rect x="201" y="425" width="14" height="14" transform="rotate(0,208,432)" />
        <rect x="201" y="439" width="14" height="14" transform="rotate(0,208,446)" />
        <rect x="215" y="33" width="14" height="14" transform="rotate(0,222,40)" />
        <rect x="215" y="61" width="14" height="14" transform="rotate(0,222,68)" />
        <rect x="215" y="103" width="14" height="14" transform="rotate(0,222,110)" />
        <rect x="215" y="117" width="14" height="14" transform="rotate(0,222,124)" />
        <rect x="215" y="131" width="14" height="14" transform="rotate(0,222,138)" />
        <rect x="215" y="159" width="14" height="14" transform="rotate(0,222,166)" />
        <rect x="215" y="201" width="14" height="14" transform="rotate(0,222,208)" />
        <rect x="215" y="243" width="14" height="14" transform="rotate(0,222,250)" />
        <rect x="215" y="369" width="14" height="14" transform="rotate(0,222,376)" />
        <rect x="215" y="439" width="14" height="14" transform="rotate(0,222,446)" />
        <rect x="229" y="19" width="14" height="14" transform="rotate(0,236,26)" />
        <rect x="229" y="47" width="14" height="14" transform="rotate(0,236,54)" />
        <rect x="229" y="61" width="14" height="14" transform="rotate(0,236,68)" />
        <rect x="229" y="75" width="14" height="14" transform="rotate(0,236,82)" />
        <rect x="229" y="117" width="14" height="14" transform="rotate(0,236,124)" />
        <rect x="229" y="145" width="14" height="14" transform="rotate(0,236,152)" />
        <rect x="229" y="187" width="14" height="14" transform="rotate(0,236,194)" />
        <rect x="229" y="215" width="14" height="14" transform="rotate(0,236,222)" />
        <rect x="229" y="229" width="14" height="14" transform="rotate(0,236,236)" />
        <rect x="229" y="257" width="14" height="14" transform="rotate(0,236,264)" />
        <rect x="229" y="285" width="14" height="14" transform="rotate(0,236,292)" />
        <rect x="229" y="327" width="14" height="14" transform="rotate(0,236,334)" />
        <rect x="229" y="369" width="14" height="14" transform="rotate(0,236,376)" />
        <rect x="229" y="383" width="14" height="14" transform="rotate(0,236,390)" />
        <rect x="229" y="397" width="14" height="14" transform="rotate(0,236,404)" />
        <rect x="229" y="425" width="14" height="14" transform="rotate(0,236,432)" />
        <rect x="229" y="439" width="14" height="14" transform="rotate(0,236,446)" />
        <rect x="229" y="467" width="14" height="14" transform="rotate(0,236,474)" />
        <rect x="243" y="89" width="14" height="14" transform="rotate(0,250,96)" />
        <rect x="243" y="103" width="14" height="14" transform="rotate(0,250,110)" />
        <rect x="243" y="145" width="14" height="14" transform="rotate(0,250,152)" />
        <rect x="243" y="159" width="14" height="14" transform="rotate(0,250,166)" />
        <rect x="243" y="173" width="14" height="14" transform="rotate(0,250,180)" />
        <rect x="243" y="201" width="14" height="14" transform="rotate(0,250,208)" />
        <rect x="243" y="257" width="14" height="14" transform="rotate(0,250,264)" />
        <rect x="243" y="271" width="14" height="14" transform="rotate(0,250,278)" />
        <rect x="243" y="285" width="14" height="14" transform="rotate(0,250,292)" />
        <rect x="243" y="383" width="14" height="14" transform="rotate(0,250,390)" />
        <rect x="243" y="397" width="14" height="14" transform="rotate(0,250,404)" />
        <rect x="243" y="411" width="14" height="14" transform="rotate(0,250,418)" />
        <rect x="243" y="425" width="14" height="14" transform="rotate(0,250,432)" />
        <rect x="257" y="47" width="14" height="14" transform="rotate(0,264,54)" />
        <rect x="257" y="61" width="14" height="14" transform="rotate(0,264,68)" />
        <rect x="257" y="75" width="14" height="14" transform="rotate(0,264,82)" />
        <rect x="257" y="131" width="14" height="14" transform="rotate(0,264,138)" />
        <rect x="257" y="173" width="14" height="14" transform="rotate(0,264,180)" />
        <rect x="257" y="229" width="14" height="14" transform="rotate(0,264,236)" />
        <rect x="257" y="243" width="14" height="14" transform="rotate(0,264,250)" />
        <rect x="257" y="257" width="14" height="14" transform="rotate(0,264,264)" />
        <rect x="257" y="271" width="14" height="14" transform="rotate(0,264,278)" />
        <rect x="257" y="285" width="14" height="14" transform="rotate(0,264,292)" />
        <rect x="257" y="313" width="14" height="14" transform="rotate(0,264,320)" />
        <rect x="257" y="355" width="14" height="14" transform="rotate(0,264,362)" />
        <rect x="257" y="369" width="14" height="14" transform="rotate(0,264,376)" />
        <rect x="257" y="383" width="14" height="14" transform="rotate(0,264,390)" />
        <rect x="257" y="411" width="14" height="14" transform="rotate(0,264,418)" />
        <rect x="257" y="439" width="14" height="14" transform="rotate(0,264,446)" />
        <rect x="257" y="467" width="14" height="14" transform="rotate(0,264,474)" />
        <rect x="271" y="19" width="14" height="14" transform="rotate(0,278,26)" />
        <rect x="271" y="61" width="14" height="14" transform="rotate(0,278,68)" />
        <rect x="271" y="89" width="14" height="14" transform="rotate(0,278,96)" />
        <rect x="271" y="103" width="14" height="14" transform="rotate(0,278,110)" />
        <rect x="271" y="117" width="14" height="14" transform="rotate(0,278,124)" />
        <rect x="271" y="145" width="14" height="14" transform="rotate(0,278,152)" />
        <rect x="271" y="159" width="14" height="14" transform="rotate(0,278,166)" />
        <rect x="271" y="173" width="14" height="14" transform="rotate(0,278,180)" />
        <rect x="271" y="215" width="14" height="14" transform="rotate(0,278,222)" />
        <rect x="271" y="243" width="14" height="14" transform="rotate(0,278,250)" />
        <rect x="271" y="257" width="14" height="14" transform="rotate(0,278,264)" />
        <rect x="271" y="271" width="14" height="14" transform="rotate(0,278,278)" />
        <rect x="271" y="285" width="14" height="14" transform="rotate(0,278,292)" />
        <rect x="271" y="299" width="14" height="14" transform="rotate(0,278,306)" />
        <rect x="271" y="341" width="14" height="14" transform="rotate(0,278,348)" />
        <rect x="271" y="355" width="14" height="14" transform="rotate(0,278,362)" />
        <rect x="271" y="369" width="14" height="14" transform="rotate(0,278,376)" />
        <rect x="271" y="425" width="14" height="14" transform="rotate(0,278,432)" />
        <rect x="271" y="439" width="14" height="14" transform="rotate(0,278,446)" />
        <rect x="271" y="453" width="14" height="14" transform="rotate(0,278,460)" />
        <rect x="271" y="467" width="14" height="14" transform="rotate(0,278,474)" />
        <rect x="285" y="61" width="14" height="14" transform="rotate(0,292,68)" />
        <rect x="285" y="75" width="14" height="14" transform="rotate(0,292,82)" />
        <rect x="285" y="117" width="14" height="14" transform="rotate(0,292,124)" />
        <rect x="285" y="145" width="14" height="14" transform="rotate(0,292,152)" />
        <rect x="285" y="201" width="14" height="14" transform="rotate(0,292,208)" />
        <rect x="285" y="257" width="14" height="14" transform="rotate(0,292,264)" />
        <rect x="285" y="271" width="14" height="14" transform="rotate(0,292,278)" />
        <rect x="285" y="285" width="14" height="14" transform="rotate(0,292,292)" />
        <rect x="285" y="299" width="14" height="14" transform="rotate(0,292,306)" />
        <rect x="285" y="313" width="14" height="14" transform="rotate(0,292,320)" />
        <rect x="285" y="341" width="14" height="14" transform="rotate(0,292,348)" />
        <rect x="285" y="383" width="14" height="14" transform="rotate(0,292,390)" />
        <rect x="285" y="397" width="14" height="14" transform="rotate(0,292,404)" />
        <rect x="285" y="411" width="14" height="14" transform="rotate(0,292,418)" />
        <rect x="285" y="425" width="14" height="14" transform="rotate(0,292,432)" />
        <rect x="285" y="439" width="14" height="14" transform="rotate(0,292,446)" />
        <rect x="299" y="19" width="14" height="14" transform="rotate(0,306,26)" />
        <rect x="299" y="47" width="14" height="14" transform="rotate(0,306,54)" />
        <rect x="299" y="89" width="14" height="14" transform="rotate(0,306,96)" />
        <rect x="299" y="103" width="14" height="14" transform="rotate(0,306,110)" />
        <rect x="299" y="131" width="14" height="14" transform="rotate(0,306,138)" />
        <rect x="299" y="159" width="14" height="14" transform="rotate(0,306,166)" />
        <rect x="299" y="215" width="14" height="14" transform="rotate(0,306,222)" />
        <rect x="299" y="243" width="14" height="14" transform="rotate(0,306,250)" />
        <rect x="299" y="257" width="14" height="14" transform="rotate(0,306,264)" />
        <rect x="299" y="271" width="14" height="14" transform="rotate(0,306,278)" />
        <rect x="299" y="285" width="14" height="14" transform="rotate(0,306,292)" />
        <rect x="299" y="299" width="14" height="14" transform="rotate(0,306,306)" />
        <rect x="299" y="313" width="14" height="14" transform="rotate(0,306,320)" />
        <rect x="299" y="341" width="14" height="14" transform="rotate(0,306,348)" />
        <rect x="299" y="355" width="14" height="14" transform="rotate(0,306,362)" />
        <rect x="299" y="397" width="14" height="14" transform="rotate(0,306,404)" />
        <rect x="299" y="425" width="14" height="14" transform="rotate(0,306,432)" />
        <rect x="299" y="467" width="14" height="14" transform="rotate(0,306,474)" />
        <rect x="313" y="19" width="14" height="14" transform="rotate(0,320,26)" />
        <rect x="313" y="47" width="14" height="14" transform="rotate(0,320,54)" />
        <rect x="313" y="61" width="14" height="14" transform="rotate(0,320,68)" />
        <rect x="313" y="131" width="14" height="14" transform="rotate(0,320,138)" />
        <rect x="313" y="159" width="14" height="14" transform="rotate(0,320,166)" />
        <rect x="313" y="173" width="14" height="14" transform="rotate(0,320,180)" />
        <rect x="313" y="201" width="14" height="14" transform="rotate(0,320,208)" />
        <rect x="313" y="257" width="14" height="14" transform="rotate(0,320,264)" />
        <rect x="313" y="299" width="14" height="14" transform="rotate(0,320,306)" />
        <rect x="313" y="327" width="14" height="14" transform="rotate(0,320,334)" />
        <rect x="313" y="341" width="14" height="14" transform="rotate(0,320,348)" />
        <rect x="313" y="355" width="14" height="14" transform="rotate(0,320,362)" />
        <rect x="313" y="397" width="14" height="14" transform="rotate(0,320,404)" />
        <rect x="313" y="411" width="14" height="14" transform="rotate(0,320,418)" />
        <rect x="313" y="425" width="14" height="14" transform="rotate(0,320,432)" />
        <rect x="327" y="19" width="14" height="14" transform="rotate(0,334,26)" />
        <rect x="327" y="61" width="14" height="14" transform="rotate(0,334,68)" />
        <rect x="327" y="89" width="14" height="14" transform="rotate(0,334,96)" />
        <rect x="327" y="103" width="14" height="14" transform="rotate(0,334,110)" />
        <rect x="327" y="131" width="14" height="14" transform="rotate(0,334,138)" />
        <rect x="327" y="145" width="14" height="14" transform="rotate(0,334,152)" />
        <rect x="327" y="243" width="14" height="14" transform="rotate(0,334,250)" />
        <rect x="327" y="271" width="14" height="14" transform="rotate(0,334,278)" />
        <rect x="327" y="313" width="14" height="14" transform="rotate(0,334,320)" />
        <rect x="327" y="341" width="14" height="14" transform="rotate(0,334,348)" />
        <rect x="327" y="383" width="14" height="14" transform="rotate(0,334,390)" />
        <rect x="327" y="453" width="14" height="14" transform="rotate(0,334,460)" />
        <rect x="327" y="467" width="14" height="14" transform="rotate(0,334,474)" />
        <rect x="341" y="19" width="14" height="14" transform="rotate(0,348,26)" />
        <rect x="341" y="89" width="14" height="14" transform="rotate(0,348,96)" />
        <rect x="341" y="131" width="14" height="14" transform="rotate(0,348,138)" />
        <rect x="341" y="145" width="14" height="14" transform="rotate(0,348,152)" />
        <rect x="341" y="159" width="14" height="14" transform="rotate(0,348,166)" />
        <rect x="341" y="187" width="14" height="14" transform="rotate(0,348,194)" />
        <rect x="341" y="201" width="14" height="14" transform="rotate(0,348,208)" />
        <rect x="341" y="215" width="14" height="14" transform="rotate(0,348,222)" />
        <rect x="341" y="229" width="14" height="14" transform="rotate(0,348,236)" />
        <rect x="341" y="243" width="14" height="14" transform="rotate(0,348,250)" />
        <rect x="341" y="271" width="14" height="14" transform="rotate(0,348,278)" />
        <rect x="341" y="341" width="14" height="14" transform="rotate(0,348,348)" />
        <rect x="341" y="383" width="14" height="14" transform="rotate(0,348,390)" />
        <rect x="341" y="397" width="14" height="14" transform="rotate(0,348,404)" />
        <rect x="341" y="425" width="14" height="14" transform="rotate(0,348,432)" />
        <rect x="341" y="439" width="14" height="14" transform="rotate(0,348,446)" />
        <rect x="341" y="467" width="14" height="14" transform="rotate(0,348,474)" />
        <rect x="355" y="19" width="14" height="14" transform="rotate(0,362,26)" />
        <rect x="355" y="33" width="14" height="14" transform="rotate(0,362,40)" />
        <rect x="355" y="61" width="14" height="14" transform="rotate(0,362,68)" />
        <rect x="355" y="75" width="14" height="14" transform="rotate(0,362,82)" />
        <rect x="355" y="103" width="14" height="14" transform="rotate(0,362,110)" />
        <rect x="355" y="117" width="14" height="14" transform="rotate(0,362,124)" />
        <rect x="355" y="173" width="14" height="14" transform="rotate(0,362,180)" />
        <rect x="355" y="187" width="14" height="14" transform="rotate(0,362,194)" />
        <rect x="355" y="201" width="14" height="14" transform="rotate(0,362,208)" />
        <rect x="355" y="215" width="14" height="14" transform="rotate(0,362,222)" />
        <rect x="355" y="229" width="14" height="14" transform="rotate(0,362,236)" />
        <rect x="355" y="271" width="14" height="14" transform="rotate(0,362,278)" />
        <rect x="355" y="285" width="14" height="14" transform="rotate(0,362,292)" />
        <rect x="355" y="327" width="14" height="14" transform="rotate(0,362,334)" />
        <rect x="355" y="341" width="14" height="14" transform="rotate(0,362,348)" />
        <rect x="355" y="355" width="14" height="14" transform="rotate(0,362,362)" />
        <rect x="355" y="369" width="14" height="14" transform="rotate(0,362,376)" />
        <rect x="355" y="383" width="14" height="14" transform="rotate(0,362,390)" />
        <rect x="355" y="397" width="14" height="14" transform="rotate(0,362,404)" />
        <rect x="355" y="411" width="14" height="14" transform="rotate(0,362,418)" />
        <rect x="355" y="425" width="14" height="14" transform="rotate(0,362,432)" />
        <rect x="355" y="467" width="14" height="14" transform="rotate(0,362,474)" />
        <rect x="369" y="131" width="14" height="14" transform="rotate(0,376,138)" />
        <rect x="369" y="145" width="14" height="14" transform="rotate(0,376,152)" />
        <rect x="369" y="187" width="14" height="14" transform="rotate(0,376,194)" />
        <rect x="369" y="201" width="14" height="14" transform="rotate(0,376,208)" />
        <rect x="369" y="243" width="14" height="14" transform="rotate(0,376,250)" />
        <rect x="369" y="257" width="14" height="14" transform="rotate(0,376,264)" />
        <rect x="369" y="271" width="14" height="14" transform="rotate(0,376,278)" />
        <rect x="369" y="299" width="14" height="14" transform="rotate(0,376,306)" />
        <rect x="369" y="327" width="14" height="14" transform="rotate(0,376,334)" />
        <rect x="369" y="355" width="14" height="14" transform="rotate(0,376,362)" />
        <rect x="369" y="411" width="14" height="14" transform="rotate(0,376,418)" />
        <rect x="369" y="439" width="14" height="14" transform="rotate(0,376,446)" />
        <rect x="369" y="453" width="14" height="14" transform="rotate(0,376,460)" />
        <rect x="383" y="173" width="14" height="14" transform="rotate(0,390,180)" />
        <rect x="383" y="187" width="14" height="14" transform="rotate(0,390,194)" />
        <rect x="383" y="201" width="14" height="14" transform="rotate(0,390,208)" />
        <rect x="383" y="215" width="14" height="14" transform="rotate(0,390,222)" />
        <rect x="383" y="229" width="14" height="14" transform="rotate(0,390,236)" />
        <rect x="383" y="271" width="14" height="14" transform="rotate(0,390,278)" />
        <rect x="383" y="285" width="14" height="14" transform="rotate(0,390,292)" />
        <rect x="383" y="313" width="14" height="14" transform="rotate(0,390,320)" />
        <rect x="383" y="327" width="14" height="14" transform="rotate(0,390,334)" />
        <rect x="383" y="341" width="14" height="14" transform="rotate(0,390,348)" />
        <rect x="383" y="355" width="14" height="14" transform="rotate(0,390,362)" />
        <rect x="383" y="383" width="14" height="14" transform="rotate(0,390,390)" />
        <rect x="383" y="411" width="14" height="14" transform="rotate(0,390,418)" />
        <rect x="383" y="439" width="14" height="14" transform="rotate(0,390,446)" />
        <rect x="397" y="131" width="14" height="14" transform="rotate(0,404,138)" />
        <rect x="397" y="173" width="14" height="14" transform="rotate(0,404,180)" />
        <rect x="397" y="187" width="14" height="14" transform="rotate(0,404,194)" />
        <rect x="397" y="215" width="14" height="14" transform="rotate(0,404,222)" />
        <rect x="397" y="229" width="14" height="14" transform="rotate(0,404,236)" />
        <rect x="397" y="243" width="14" height="14" transform="rotate(0,404,250)" />
        <rect x="397" y="257" width="14" height="14" transform="rotate(0,404,264)" />
        <rect x="397" y="299" width="14" height="14" transform="rotate(0,404,306)" />
        <rect x="397" y="355" width="14" height="14" transform="rotate(0,404,362)" />
        <rect x="397" y="411" width="14" height="14" transform="rotate(0,404,418)" />
        <rect x="397" y="439" width="14" height="14" transform="rotate(0,404,446)" />
        <rect x="397" y="453" width="14" height="14" transform="rotate(0,404,460)" />
        <rect x="411" y="131" width="14" height="14" transform="rotate(0,418,138)" />
        <rect x="411" y="187" width="14" height="14" transform="rotate(0,418,194)" />
        <rect x="411" y="201" width="14" height="14" transform="rotate(0,418,208)" />
        <rect x="411" y="215" width="14" height="14" transform="rotate(0,418,222)" />
        <rect x="411" y="229" width="14" height="14" transform="rotate(0,418,236)" />
        <rect x="411" y="271" width="14" height="14" transform="rotate(0,418,278)" />
        <rect x="411" y="285" width="14" height="14" transform="rotate(0,418,292)" />
        <rect x="411" y="299" width="14" height="14" transform="rotate(0,418,306)" />
        <rect x="411" y="313" width="14" height="14" transform="rotate(0,418,320)" />
        <rect x="411" y="341" width="14" height="14" transform="rotate(0,418,348)" />
        <rect x="411" y="355" width="14" height="14" transform="rotate(0,418,362)" />
        <rect x="411" y="369" width="14" height="14" transform="rotate(0,418,376)" />
        <rect x="411" y="383" width="14" height="14" transform="rotate(0,418,390)" />
        <rect x="411" y="397" width="14" height="14" transform="rotate(0,418,404)" />
        <rect x="411" y="411" width="14" height="14" transform="rotate(0,418,418)" />
        <rect x="411" y="453" width="14" height="14" transform="rotate(0,418,460)" />
        <rect x="411" y="467" width="14" height="14" transform="rotate(0,418,474)" />
        <rect x="425" y="131" width="14" height="14" transform="rotate(0,432,138)" />
        <rect x="425" y="145" width="14" height="14" transform="rotate(0,432,152)" />
        <rect x="425" y="173" width="14" height="14" transform="rotate(0,432,180)" />
        <rect x="425" y="243" width="14" height="14" transform="rotate(0,432,250)" />
        <rect x="425" y="299" width="14" height="14" transform="rotate(0,432,306)" />
        <rect x="425" y="313" width="14" height="14" transform="rotate(0,432,320)" />
        <rect x="425" y="467" width="14" height="14" transform="rotate(0,432,474)" />
        <rect x="439" y="145" width="14" height="14" transform="rotate(0,446,152)" />
        <rect x="439" y="159" width="14" height="14" transform="rotate(0,446,166)" />
        <rect x="439" y="187" width="14" height="14" transform="rotate(0,446,194)" />
        <rect x="439" y="201" width="14" height="14" transform="rotate(0,446,208)" />
        <rect x="439" y="215" width="14" height="14" transform="rotate(0,446,222)" />
        <rect x="439" y="243" width="14" height="14" transform="rotate(0,446,250)" />
        <rect x="439" y="257" width="14" height="14" transform="rotate(0,446,264)" />
        <rect x="439" y="271" width="14" height="14" transform="rotate(0,446,278)" />
        <rect x="439" y="299" width="14" height="14" transform="rotate(0,446,306)" />
        <rect x="439" y="327" width="14" height="14" transform="rotate(0,446,334)" />
        <rect x="439" y="355" width="14" height="14" transform="rotate(0,446,362)" />
        <rect x="439" y="397" width="14" height="14" transform="rotate(0,446,404)" />
        <rect x="439" y="411" width="14" height="14" transform="rotate(0,446,418)" />
        <rect x="439" y="439" width="14" height="14" transform="rotate(0,446,446)" />
        <rect x="439" y="453" width="14" height="14" transform="rotate(0,446,460)" />
        <rect x="439" y="467" width="14" height="14" transform="rotate(0,446,474)" />
        <rect x="453" y="131" width="14" height="14" transform="rotate(0,460,138)" />
        <rect x="453" y="145" width="14" height="14" transform="rotate(0,460,152)" />
        <rect x="453" y="187" width="14" height="14" transform="rotate(0,460,194)" />
        <rect x="453" y="411" width="14" height="14" transform="rotate(0,460,418)" />
        <rect x="453" y="425" width="14" height="14" transform="rotate(0,460,432)" />
        <rect x="453" y="439" width="14" height="14" transform="rotate(0,460,446)" />
        <rect x="453" y="453" width="14" height="14" transform="rotate(0,460,460)" />
        <rect x="453" y="467" width="14" height="14" transform="rotate(0,460,474)" />
        <rect x="467" y="159" width="14" height="14" transform="rotate(0,474,166)" />
        <rect x="467" y="173" width="14" height="14" transform="rotate(0,474,180)" />
        <rect x="467" y="243" width="14" height="14" transform="rotate(0,474,250)" />
        <rect x="467" y="271" width="14" height="14" transform="rotate(0,474,278)" />
        <rect x="467" y="299" width="14" height="14" transform="rotate(0,474,306)" />
        <rect x="467" y="327" width="14" height="14" transform="rotate(0,474,334)" />
        <rect x="467" y="341" width="14" height="14" transform="rotate(0,474,348)" />
        <rect x="467" y="355" width="14" height="14" transform="rotate(0,474,362)" />
        <rect x="467" y="369" width="14" height="14" transform="rotate(0,474,376)" />
        <rect x="467" y="397" width="14" height="14" transform="rotate(0,474,404)" />
        <path clip-rule="evenodd" d="M 19 19v 98h 98v -98zM 33 33h 70v 70h -70z" transform="rotate(0,68,68)" />
        <rect x="47" y="47" width="42" height="42" transform="rotate(0,68,68)" />
        <path clip-rule="evenodd" d="M 383 19v 98h 98v -98zM 397 33h 70v 70h -70z" transform="rotate(90,432,68)" />
        <rect x="411" y="47" width="42" height="42" transform="rotate(90,432,68)" />
        <path clip-rule="evenodd" d="M 19 383v 98h 98v -98zM 33 397h 70v 70h -70z" transform="rotate(-90,68,432)" />
        <rect x="47" y="411" width="42" height="42" transform="rotate(-90,68,432)" />
      </clipPath>
    </defs>
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-background-color')" fill="#fff" />
    <rect x="0" y="0" height="500" width="500" clip-path="url('#clip-path-dot-color')" fill="#000000" />
  </svg>
</template>
